/* eslint import/no-webpack-loader-syntax: off */
import AsyncSelect from "react-select/async";
import { Fragment, useContext, useEffect, useState, useRef } from "react";
import {
  Alert,
  Button,
  Card,
  ProgressBar,
  Spinner,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import { isEmpty, isNull } from "lodash";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import { SMSDispatchLogList } from "../SMSDispatchLogAdmin/SMSDispatchLogAdmin";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import OnTypeSearch from "./../../../utils/OnTypeSearch/OnTypeSearch";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import EditOrderParams from "./EditOrderParams/EditOrderParams";
import CustomDateTimePicker from "../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import WalletAdminContext from "../../../context/Admin/WalletAdminContext/WalletAdminContext";
import { UserWallet } from "../WalletAdmin/WalletAdmin";
import {
  areYouSureMessage,
  modalErrorMessage,
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { orderAdminContext } from "../../../context/Admin/OrderAdminContext/OrderAdminContext";
import {
  convertDate,
  numberSeparate,
  rateType,
  defaultPicture,
  personnelTypeButton,
  removeNumberSeparate,
  paymentStatusItems,
  activityTypeItems,
  expertTypeItems,
  convertPercentNumber,
  orderProgressToText,
  orderProgressToColor,
  convertDateShort,
} from "../../../utils";
import {
  ConvertCurrency,
  ConvertCurrencyToText,
} from "../../../utils/Currency/Currency";
import OSMMap from "../../../utils/OSMMap/OSMMap";
import TaraRefundAdminContext from "../../../context/Admin/TaraRefundAdminContext/TaraRefundAdminContext";
import TaraRefundAdmin from "../../../components/Admin/TaraRefundAdmin/TaraRefundAdmin";

const OrderAdmin = () => {
  const permission = useSelector((state) => state.permission);
  const isLoader = useSelector((state) => state.isLoader);
  const appTypeChoice = useSelector(
    (state) => state.appConfigs.APP_TYPE_CHOICES
  );
  const invoiceItemTypes = useSelector(
    (state) => state.appConfigs.INVOICE_ITEM_TYPES
  );

  const { pathname } = useLocation();

  const { orderId } = useParams();

  const {
    order,
    personnels,
    setPersonnels,
    personnel,
    setPersonnel,
    config,
    surveyItems,
    logs,
    handleChangeSurveyItemList,
    isExistingSurveyItem,
    personnelStep,
    personnel_notification,
    setPersonnel_notification,
    expert_type,
    setExpert_type,
    activity_type,
    setActivity_type,
    isActive,
    setIsActive,
    workCount,
    setWorkCount,
    isSpecial,
    setIsSpecial,
    isShowLogs,
    isShowPersonnelModal,
    personnel_order,
    isPersonnelLoading,
    personnelSearch,
    setPersonnelSearch,
    personnelType,
    setPersonnelType,
    isShowSurveyModal,
    isPositiveTab,
    setIsPositiveTab,
    rate,
    setRate,
    fee,
    setFee,
    piece,
    setPiece,
    categories,
    categoriesWithId,
    filterCategory,
    setFilterCategory,
    surveyText,
    setSurveyText,
    transportation,
    setTransportation,
    extraItems,
    setExtraItems,
    tax,
    setTax,
    isTax,
    setIsTax,
    is_official,
    setIs_official,
    useWallet,
    setUseWallet,
    is_paid,
    setIs_paid,
    rechargeWallet,
    setRechargeWallet,
    amount,
    invoiceMethod,
    setInvoiceMethod,
    invoiceId,
    description,
    setDescription,
    isShowInvoiceModal,
    handleCreateInvoice,
    handleEditInvoice,
    handleShowInvoiceModal,
    handleCloseInvoiceModal,
    handleShowSurveyModal,
    handleCloseSurveyModal,
    handleShowPersonnelModal,
    handleClosePersonnelModal,
    handleGetOrder,
    handleGetCategoryItemList,
    handleSearchServices,
    handleGetServices,
    handleSendSMSToPersonnel,
    handleSendOrderToPersonnelSMS,
    handleGetLogsOrder,
    handleEditPersonnel,
    handleRemovePersonnel,
    handleGetPersonnels,
    handleGetPersonnel,
    handleAddPersonnel,
    handleSendInvoiceToClient,
    handleGetSurveyItemList,
    handleSendSurvey,
    handleEditProgress,
    checkViewOrders,
    handleRemovePenaltyViolation,
    cities,
    city_filter,
    setCity_filter,
    personnelSort,
    setPersonnelSort,
  } = useContext(orderAdminContext);

  // Set State After Typing
  const onTypePersonnelSearch = OnTypeSearch(setPersonnelSearch);

  const [activeTab, setActiveTab] = useState("0");

  useEffect(() => {
    handleGetCategoryItemList();
    handleGetServices();
    handleGetSurveyItemList();
  }, []);

  useEffect(() => {
    if (activeTab === "9" && !isShowLogs) handleGetLogsOrder(order?.id);
  }, [activeTab]);

  useEffect(() => {
    if (orderId) {
      checkViewOrders(orderId, true);
      handleGetOrder(orderId);
    }
  }, [orderId]);

  useEffect(() => {
    if (isShowPersonnelModal && personnelSearch) handleGetPersonnels();
    else setPersonnels([]);
  }, [
    personnelSearch,
    personnelType,
    isSpecial,
    isActive,
    workCount,
    expert_type,
    activity_type,
  ]);

  const onNavigate = (pk) => {
    window.open(`${pathname?.replace(/Orders.*/, "Orders")}/${pk}`, "_blank");
  };

  let totalInvoice =
    Number(fee) +
    Number(piece) +
    Number(transportation) +
    extraItems?.reduce((acc, item) => acc + Number(item.price), 0) -
    Number(amount) -
    (useWallet ? Number(order?.client?.wallet.current_balance) : 0);

  const _tax = isTax ? totalInvoice * (+tax / 100) : 0;
  totalInvoice += _tax;

  const [itemName, setItemName] = useState("");
  const [itemPrice, setItemPrice] = useState("");
  const [itemDescription, setItemDescription] = useState("");

  const handleAddItem = (event) => {
    event?.preventDefault();

    if (!itemName) return toastErrorMessage("عنوان الزامی است");
    if (!itemPrice) return toastErrorMessage("مبلغ الزامی است");

    areYouSureMessage(() => {
      setExtraItems([
        ...(extraItems ?? []),
        {
          name: itemName,
          price: +itemPrice,
          description: itemDescription,
        },
      ]);

      setItemName("");
      setItemPrice("");
      setItemDescription("");
    }, `از افزودن ${itemName} به مبلغ ${numberSeparate(itemPrice)} ریال اطمینان دارید؟`);
  };
  const handleRemoveItem = (index) =>
    setExtraItems(extraItems?.filter((_, _i) => _i !== index));

  const isTaraPayment = order?.invoice?.payment?.some(
  (p) => [1, 4, 6].includes(p.status) && (p.description?.includes("تارا") || p.message?.includes("تارا"))
);

  return (
    <>
      <SiteTitle title="سفارش" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "سفارش", type: "a" },
        ]}
        title="جزئیات سفارش"
      />

      {/* Operator Buttons */}
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {permission.admin_create_update && (
                <button
                  onClick={() =>
                    handleGetOrder(order?.id, () =>
                      handleShowPersonnelModal(order?.pk)
                    )
                  }
                  className="btn btn-info mr-2"
                >
                  ویرایش پرسنل
                </button>
              )}
              {permission.admin_create_update && (
                <EditOrderParams data={order} />
              )}
              <WalletAdminContext isUser>
                <UserWallet data={order?.client} />
              </WalletAdminContext>
              {(!isEmpty(order?.personnel) || !isEmpty(order?.old_personnel)) && (
                <>
                  <FailureRequest />
                  <Violation />
                </>
              )}
            </div>
            <div>
              <button
                onClick={() => window.close()}
                className="btn btn-light mr-2"
              >
                انصراف
              </button>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="row justify-content-between align-items-center">
          <div className="col">
            <ProgressBar
              label={orderProgressToText(order.progress)}
              striped
              animated
              variant={orderProgressToColor(order.progress)}
              now={order.progress}
              className="h-25"
            />
          </div>
          {order.progress < 90 && (
            <div className="col-auto">
              <span className="mr-2">تغییر به:</span>
              <Button
                size="sm"
                onClick={() =>
                  areYouSureMessage(
                    () =>
                      handleEditProgress(
                        order.progress === 0
                          ? 50
                          : order.progress === 50
                            ? 75
                            : 90
                      ),
                    "آیا از ویرایش پیشرفت اطمینان دارید؟"
                  )
                }
                color={orderProgressToColor(order.progress)}
              >
                {orderProgressToText(
                  order.progress === 0 ? 50 : order.progress === 50 ? 75 : 90
                )}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
      {!!order?.return_user_order?.pk && (
        <Card>
          <Card.Body>
            <Alert
              variant="danger"
              className="d-flex justify-content-between align-items-center mb-0"
            >
              <div>
                سفارش بازگشتی: سفارش قبلی لغو شده توسط کاربر با تاریخ ثبت{" "}
                {convertDate(order?.return_user_order?.created)} از خدمت{" "}
                {order?.return_user_order?.service}
              </div>
              <button
                onClick={() => onNavigate(order?.return_user_order?.pk)}
                className="btn btn-primary px-4 ml-2"
              >
                مشاهده
              </button>
            </Alert>
          </Card.Body>
        </Card>
      )}

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
        {/* Info */}
        <Tab className="card card-body" eventKey="0" title="اطلاعات سفارش">
          {!isEmpty(order?.discount?.title) && (
            <>
              <p className="alert alert-success text-center">
                <span className="fw-bold">{order?.discount?.percent}</span>{" "}
                درصد تخفیف{" "}
                {order?.discount?.min_invoice_amount && (
                  <span>
                    برای سفارش هایی با مبلغ حداقل{" "}
                    <ConvertCurrency
                      price={order?.discount?.min_invoice_amount}
                    />
                    ریال
                  </span>
                )}{" "}
                تا سقف{" "}
                <span className="fw-bold">
                  <ConvertCurrency
                    price={order?.discount?.max_discount_amount}
                  />{" "}
                  ریال
                </span>{" "}
                بر روی سفارش اعمال شده است
              </p>
              <p className="alert alert-primary text-center">
                عنوان: {order?.discount?.title}
                <br />
                کد تخفیف: {order?.discount?.ref_num}
                <hr />
                <span className="fw-bold">
                  {order?.discount?.percent}
                </span>{" "}
                مبلغ تخفیف:{" "}
                <ConvertCurrency price={order?.discount?.amount} />
                <br />
                درصد تخفیف: {order?.discount?.percent}%<br />
                حداقل مبلغ فاکتور{" "}
                <ConvertCurrency
                  price={order?.discount?.min_invoice_amount}
                />
                <br />
                حداکثر میزان تخفیف:{" "}
                <ConvertCurrency
                  price={order?.discount?.max_discount_amount}
                />
              </p>
            </>
          )}

          {order?.use_wallet && (
            <Alert variant="primary" className="font-weight-bold text-center">
              کاربر مایل به استفاده از موجودی کیف پول خود است
            </Alert>
          )}

          {order?.is_official_invoice && (
            <Alert variant="info" className="font-weight-bold text-center">
              سفارش دارای فاکتور رسمی است
            </Alert>
          )}

          <div className="row">
            {/* User */}
            <ItemInfo label="نام و نام خانوادگی">
              <p>
                {order?.client?.first_name} {order?.client?.last_name}
              </p>
            </ItemInfo>
            <ItemInfo label="شماره موبایل">
              <p>
                <a href={`tel:${order?.client?.mobile}`}>
                  {order?.client?.mobile}
                </a>
              </p>
            </ItemInfo>
            <ItemInfo label="نوع سفارش">
              <p>{order?.service?.name}</p>
            </ItemInfo>
            <ItemInfo label="آدرس">
              <p>{order?.address?.address}</p>
            </ItemInfo>
            <ItemInfo label="تاریخ ثبت سفارش">
              <p>{convertDate(order?.created)}</p>
            </ItemInfo>
            <ItemInfo label="کد پیگیری">
              <p>{order.ref_num}</p>
            </ItemInfo>
            <ItemInfo label="سازمان مشتری">
              <p>
                {order?.client?.employer ? (
                  <span className="badge badge-primary font-weight-bold">
                    {order?.client?.employer?.name}
                  </span>
                ) : (
                  <span className="badge badge-secondary font-weight-bold">
                    کاربر عادی
                  </span>
                )}
              </p>
            </ItemInfo>
            <ItemInfo label="نسخه اپ">
              <p>
                {order?.client?.app_type
                  ? `${appTypeChoice?.split("،")[order?.client?.app_type - 1]
                  } ${order?.client?.app_version}`
                  : "- -"}
              </p>
            </ItemInfo>
            {/* Other */}
            <ItemInfo label="وضعیت">
              <ItemStatus />
            </ItemInfo>
            {[6, 8, 9, 10].includes(order?.status) && (
              <ItemInfo label="وضعیت بازگشت مشتری">
                <ReturnUserStatusItem />
              </ItemInfo>
            )}
            <ItemInfo label="نحوه آشنایی">
              <IntroductionUserItem />
            </ItemInfo>
            {[6, 8, 9, 10].includes(order?.status) && (
              <>
                {order?.cancelingreason?.description && (
                  <ItemInfo label="دلیل لغو">
                    <span className="badge badge-danger text-wrap">
                      {order?.cancelingreason?.description}
                    </span>
                  </ItemInfo>
                )}
                {order?.failingreason?.description && (
                  <ItemInfo label="دلیل کنسلی">
                    <span className="badge badge-danger text-wrap">
                      {order?.failingreason?.description}
                    </span>
                  </ItemInfo>
                )}
              </>
            )}
            <ItemInfo label="نوع پرسنل سفارش">
              <p>
                {order?.need_personnel_special ? (
                  <span className="badge badge-primary">ویژه</span>
                ) : (
                  <span className="badge badge-secondary">عادی</span>
                )}
              </p>
            </ItemInfo>
            <ItemInfo label="شهر سفارش">
              <p>
                {order?.city && (
                  <span className="badge badge-primary">{order?.city.name}</span>
                )}
              </p>
            </ItemInfo>
            {order?.personnel_notification && (
              <ItemInfo label="پیام پرسنل">
                <p>{order?.personnel_notification}</p>
              </ItemInfo>
            )}
          </div>
          {permission.admin_create_update && (
            <>
              <hr />
              <Comments />
            </>
          )}
          {order?.address && (
            <OSMMap
              latitude={order?.address.latitude}
              longitude={order?.address.longitude}
              height="40vh"
            />
          )}
        </Tab>
        {/* Values */}
        <Tab className="card card-body" eventKey="1" title="جزئیات">
          <OrderValues values={order?.values} />
        </Tab>
        {/* Personnel */}
        {(!isEmpty(order?.personnel) || order?.assigned_technician) && (
          <Tab className="card card-body" eventKey="3" title="پرسنل">

            {/* 1. Main Personnel / Contractor */}
            {!isEmpty(order?.personnel) &&
              order?.personnel?.map((_personnel) => (
                <div key={`personnel-${_personnel?.id}`}>
                  <div className="row mb-2 align-items-center justify-content-between">
                    <div className="col-auto">
                      <img
                        className="img-fluid rounded-circle shadow"
                        src={
                          _personnel?.base64
                            ? `data:image/jpeg;base64,${_personnel?.base64}`
                            : defaultPicture
                        }
                        width={65}
                        height={65}
                        alt={`${_personnel?.first_name} ${_personnel?.last_name}`}
                      />
                    </div>
                    <div className="col">
                      {/* Only show the Contractor label if there is an assigned technician to distinguish them from */}
                      {order?.assigned_technician && (
                        <small className="text-muted d-block mb-1">
                          پیمانکار / مجری اصلی
                        </small>
                      )}
                      <h5
                        type="button"
                        className="mb-0 fw-bold"
                        onClick={() =>
                          permission.personnel_get &&
                          handleGetPersonnel(_personnel?.id)
                        }
                      >
                        {_personnel?.first_name} {_personnel?.last_name}
                      </h5>
                    </div>
                    <div className="col-auto text-center">
                      <TooltipTitle
                        title={`تماس با متخصص ${_personnel?.mobile}`}
                        placement="bottom"
                      >
                        <a href={`tel:${_personnel?.mobile}`}>
                          <i className="fa fa-phone fa-2x" />
                        </a>
                      </TooltipTitle>
                    </div>
                  </div>
                  <hr />
                </div>
              ))}

            {/* 2. Delegated Technician */}
            {order?.assigned_technician && (
              <div key={`tech-${order.assigned_technician.id}`}>
                <div className="row mb-2 align-items-center justify-content-between">
                  <div className="col-auto">
                    <img
                      className="img-fluid rounded-circle shadow border border-info"
                      src={defaultPicture}
                      width={65}
                      height={65}
                      alt={order.assigned_technician.name}
                    />
                  </div>
                  <div className="col">
                    <span className="badge badge-info mb-1">
                      تکنسین زیرمجموعه (ارجاع شده)
                    </span>
                    <h5
                      type="button"
                      className="mb-0 fw-bold text-info"
                      onClick={() =>
                        permission.personnel_get &&
                        handleGetPersonnel(order.assigned_technician.id)
                      }
                    >
                      {order.assigned_technician.name}
                    </h5>
                  </div>
                  <div className="col-auto text-center">
                    <TooltipTitle
                      title={`تماس با تکنسین ${order.assigned_technician.mobile}`}
                      placement="bottom"
                    >
                      <a href={`tel:${order.assigned_technician.mobile}`}>
                        <i className="fa fa-phone fa-2x text-info" />
                      </a>
                    </TooltipTitle>
                  </div>
                </div>
                <hr />
              </div>
            )}

          </Tab>
        )}
        {/* Old Personnel */}
        {!isEmpty(order?.old_personnel) && (
          <Tab
            className="card card-body"
            eventKey="4"
            title="پرسنل قبل (حذف شده)"
          >
            {order?.old_personnel?.map((_personnel) => (
              <>
                <div className="row mb-2 align-items-center justify-content-between">
                  <div className="col-auto">
                    <img
                      className="img-fluid rounded-circle shadow"
                      src={
                        _personnel?.personnel?.base64
                          ? `data:image/jpeg;base64,${_personnel?.personnel?.base64}`
                          : defaultPicture
                      }
                      width={65}
                      height={65}
                      alt={`${_personnel?.personnel?.first_name} ${_personnel?.personnel?.last_name}`}
                    />
                  </div>
                  <div className="col">
                    <h5
                      type="button"
                      className="mb-0 fw-bold"
                      onClick={() =>
                        handleGetPersonnel(_personnel?.personnel?.pk)
                      }
                    >
                      {_personnel?.personnel?.first_name}{" "}
                      {_personnel?.personnel?.last_name}
                    </h5>
                  </div>
                  <div className="col-auto text-center">
                    <TooltipTitle
                      title={`تماس با متخصص ${_personnel?.personnel?.mobile}`}
                      placement="bottom"
                    >
                      <a href={`tel:${_personnel?.personnel?.mobile}`}>
                        <i className="fa fa-phone fa-2x" />
                      </a>
                    </TooltipTitle>
                  </div>
                </div>
                <hr />
              </>
            ))}
          </Tab>
        )}
        {/* Survey */}
        <Tab className="card card-body" eventKey="5" title="نظرسنجی">
          <p className="text-info fw-bold text-center">
            نظرسنجی{" "}
            <TooltipTitle title="ویرایش نظرسنجی" placement="bottom">
              <i
                className="fa fa-edit text-primary cursorPointer"
                onClick={handleShowSurveyModal}
              />
            </TooltipTitle>
          </p>
          {isEmpty(order?.surveyitems) ? (
            <EmptyData title="نظرسنجی برای نمایش یافت نشد" />
          ) : (
            <>
              {order?.rating > 0 && (
                <p className="text-center">
                  {[...Array(5)].map((_, index) => (
                    <span key={index}>
                      <i
                        className={`${index < rate ? "fa" : "far"
                          } fa-star text-info fa-3x`}
                      />
                    </span>
                  ))}
                </p>
              )}
              {order.feedback && (
                <p className="alert alert-info">{order.feedback}</p>
              )}
              <div className="row">
                {order?.surveyitems?.map((_survey) => (
                  <ItemInfo>
                    <div className="row align-items-center justify-content-between">
                      <div className="col-auto">
                        <img
                          className="img-fluid rounded-circle shadow"
                          src={`${config.APP_DOWNLOAD_LINK}/static/console/${_survey.icon}`}
                          width={45}
                          height={45}
                          alt={`${_survey?.description}`}
                        />
                      </div>
                      <div className="col">
                        <h6 className="mb-0 fw-bold">{_survey?.description}</h6>
                      </div>
                    </div>
                  </ItemInfo>
                ))}
              </div>
            </>
          )}
        </Tab>
        {/* Invoice */}
        {(!!order.invoice?.pk || !isEmpty(order?.personnel)) && (
          <Tab className="card card-body" eventKey="6" title="فاکتور ">
            {/* Discount */}

            {order?.service?.name?.includes("نظافت") && ( // only show if service is cleaning
              <CleaningCalculator />
            )}

            {order.invoice?.pk ? (
              <>
                <div className="row align-items-center">
                  <ItemInfo label="شماره فاکتور">
                    {numberSeparate(order?.invoice?.pk)}
                  </ItemInfo>
                  <ItemInfo label="اجرت (ریال)">
                    <ConvertCurrency price={order?.invoice?.fee} />
                  </ItemInfo>
                  <ItemInfo label="هزینه قطعه (ریال)">
                    <ConvertCurrency price={order?.invoice?.piece} />
                  </ItemInfo>
                  <ItemInfo label="ایاب و ذهاب (ریال)">
                    <ConvertCurrency price={order?.invoice?.transportation} />
                  </ItemInfo>
                  <ItemInfo label="مالیات (ریال)">
                    <ConvertCurrency price={order?.invoice?.tax} />
                  </ItemInfo>
                  <ItemInfo label="تخفیف (ریال)">
                    <ConvertCurrency price={order?.invoice?.discount} />
                  </ItemInfo>
                  <ItemInfo label="فاکتور رسمی">
                    <i
                      className={`fa fa-${order?.invoice?.is_official ? "check" : "times"
                        } text-${order?.invoice?.is_official ? "success" : "danger"
                        }`}
                    />
                  </ItemInfo>
                  <ItemInfo label="پرداخت شده">
                    <i
                      className={`fa fa-${order?.invoice?.is_paid ? "check" : "times"
                        } text-${order?.invoice?.is_paid ? "success" : "danger"}`}
                    />
                    {"  "}{order?.invoice?.gateway}
                  </ItemInfo>
                  <ItemInfo label="نوع پرداخت">
                    <p>
                      {order?.invoice?.method === 1
                        ? "اعتبار (کیف پول)"
                        : order?.invoice?.method === 2
                          ? "درگاه پرداخت"
                          : "نقدی"}
                    </p>
                  </ItemInfo>
                  <ItemInfo label="مجموع (ریال)">
                    <ConvertCurrency price={order?.invoice?.total} />
                  </ItemInfo>
                  <ItemInfo label="استفاده از کیف پول (ریال)">
                    <ConvertCurrency price={order?.invoice?.wallet_amount_applied} />
                  </ItemInfo>
                  <ItemInfo label="توضیحات">
                    <p>{order?.invoice?.description}</p>
                  </ItemInfo>
                  {!order?.invoice?.is_paid && (
                    <>
                      {permission.invoices_send_invoice_to_client && (
                        <ItemInfo label="ارسال فاکتور">
                          <p>
                            <button
                              onClick={() =>
                                handleSendInvoiceToClient(order?.invoice?.pk)
                              }
                              className="btn btn-success btn-block"
                            >
                              <i className="fab fa-telegram-plane" /> ارسال
                              فاکتور برای مشتری
                            </button>
                          </p>
                        </ItemInfo>
                      )}
                      {permission.invoices_update && (
                        <ItemInfo label="ویرایش فاکتور">
                          <p>
                            <button
                              className="btn btn-primary btn-block"
                              onClick={() =>
                                handleShowInvoiceModal(order.invoice)
                              }
                            >
                              ویرایش
                            </button>
                          </p>
                        </ItemInfo>
                      )}
                    </>
                  )}

                  {!isEmpty(order?.invoice?.items) && (
                    <div className="col-12">
                      <Table responsive hover borderless>
                        <thead className="thead-light">
                          <th>عنوان</th>
                          <th>مبلغ (ریال)</th>
                          <th>توضیحات</th>
                        </thead>
                        <tbody>
                          {order?.invoice?.items?.map((_inv, idx) => (
                            <tr key={idx}>
                              <td>{_inv.name}</td>
                              <td>
                                <ConvertCurrency price={_inv?.price} />
                              </td>
                              <td>{_inv.description}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>

                {order?.invoice?.payment?.map((item, index) => (
                  <div key={index}>
                    <p className="text-info fw-bold text-center">
                      اطلاعات پرداخت {index + 1}
                    </p>

                    <div className="row">
                      <ItemInfo label="مبلغ">
                        <ConvertCurrency price={item?.amount} />
                      </ItemInfo>
                      <ItemInfo label="شماره کارت">
                        <p>{item?.cardnumbermasked}</p>
                      </ItemInfo>
                      <ItemInfo label="توضیحات">
                        <p>{item?.description}</p>
                      </ItemInfo>
                      <ItemInfo label="پیغام">
                        <p>{item?.message}</p>
                      </ItemInfo>
                      <ItemInfo label="تاریخ ایجاد">
                        <p>{item?.created_time}</p>
                      </ItemInfo>
                      <ItemInfo label="وضعیت">
                        <p>{paymentStatusItems[item?.status]}</p>
                      </ItemInfo>
                      <ItemInfo label="توکن">
                        <p>{item?.token}</p>
                      </ItemInfo>
                      <ItemInfo label="شماره ترمینال">
                        <p>{item?.terminalno}</p>
                      </ItemInfo>
                      <ItemInfo label="کدپیگیری">
                        <p>{item?.paygatetranid}</p>
                      </ItemInfo>
                      <ItemInfo label="rrn">
                        <p>{item?.rrn}</p>
                      </ItemInfo>
                    </div>

                    <hr />
                  </div>
                ))}
                {order?.invoice?.is_paid && isTaraPayment && (
                  <div className="row mt-4">
                    <div className="col-12">
                      <TaraRefundAdminContext>
                        <TaraRefundAdmin invoice={order.invoice} />
                      </TaraRefundAdminContext>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {permission.invoices_create && (
                  <div className="text-center">
                    <button
                      onClick={() => handleShowInvoiceModal()}
                      className="btn btn-primary"
                    >
                      ایجاد فاکتور برای این سفارش
                    </button>
                  </div>
                )}
              </>
            )}
          </Tab>
        )}
        {/* Failure Request */}
        {!isEmpty(order.failurerequest) && (
          <Tab className="card card-body" eventKey="7" title="درخواست">
            {order.failurerequest?.map((_item, index) => (
              <div>
                <p className="font-weight-bold text-center border-bottom">
                  درخواست شماره {index + 1}
                </p>
                <div className="row">
                  <ItemInfo label="مشتری">
                    <p>
                      <TooltipTitle
                        title={_item?.order?.client?.mobile}
                        placement="bottom"
                      >
                        <span>
                          {_item?.order?.client?.first_name}{" "}
                          {_item?.order?.client?.last_name}
                        </span>
                      </TooltipTitle>
                    </p>
                  </ItemInfo>
                  <ItemInfo label="تاریخ درخواست">
                    <p>{convertDate(_item?.created)}</p>
                  </ItemInfo>
                  <ItemInfo label="تاریخ ثبت سفارش">
                    <p>{convertDate(_item?.order?.created)}</p>
                  </ItemInfo>
                  <ItemInfo label="تاریخ نهایی">
                    <p>{_item?.end_date}</p>
                  </ItemInfo>
                  <ItemInfo label="ثبت تا درخواست">
                    <p>{numberSeparate(_item?.until_created)} روز</p>
                  </ItemInfo>
                  <ItemInfo label="چند روزه حل شد">
                    <p>{numberSeparate(_item?.until_solved)}</p>
                  </ItemInfo>
                  <ItemInfo label="نوع درخواست">
                    <p>{_item?.request_type?.description}</p>
                  </ItemInfo>
                  <ItemInfo label="کد پیگیری سفارش">
                    <p>{_item?.order?.ref_num}</p>
                  </ItemInfo>
                  <ItemInfo label="شماره تماس کاربر">
                    <p>{_item?.order?.client?.mobile}</p>
                  </ItemInfo>
                  <ItemInfo label="پرسنل">
                    <p>
                      {!isEmpty(_item?.order?.personnel) &&
                        _item?.order?.personnel?.map((_personnelVal, index) => (
                          <span
                            className={`d-block ${index + 1 !== _item?.order?.personnel?.length
                              ? "border-bottom"
                              : ""
                              }`}
                          >
                            <TooltipTitle
                              title={_personnelVal?.mobile ?? "ندارد"}
                              placement="bottom"
                            >
                              <span className="mx-1">
                                {_personnelVal?.first_name}{" "}
                                {_personnelVal?.last_name}
                              </span>
                            </TooltipTitle>
                          </span>
                        ))}
                    </p>
                  </ItemInfo>
                  <ItemInfo label="نتیجه نهایی">
                    <p>{_item?.result}</p>
                  </ItemInfo>
                  <ItemInfo label="چطوری راضیش کردم؟">
                    <p>{_item?.customer_satisfaction_item?.description}</p>
                  </ItemInfo>
                </div>
                {!isEmpty(_item?.comment) && (
                  <Table responsive hover borderless striped>
                    <thead className="thead-dark">
                      <tr>
                        <th>#</th>
                        <th className="normal-white_space">
                          توضیحات پشتیبانی و امور متخصصین
                        </th>
                        <th>پشتیبان</th>
                        <th>تاریخ ایجاد</th>
                      </tr>
                    </thead>
                    <tbody>
                      {_item?.comment?.map((_item, index) => (
                        <tr key={_item.id}>
                          <td>{index + 1}</td>
                          <td className="normal-white_space">
                            {_item?.comment}
                          </td>
                          <td>
                            {_item?.user?.first_name} {_item?.user?.last_name}
                          </td>
                          <td>{convertDate(_item.created)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            ))}
          </Tab>
        )}
        {/* Failure Request */}
        {!isEmpty(order.violation) && (
          <Tab className="card card-body" eventKey="8" title="تخلف">
            {order.violation?.map((_item, index) => (
              <div>
                <p className="font-weight-bold text-center border-bottom">
                  تخلف شماره {index + 1}
                </p>

                <div className="row">
                  <ItemInfo label="مشتری">
                    <p>
                      <TooltipTitle
                        title={_item?.order?.client?.mobile}
                        placement="bottom"
                      >
                        <span>
                          {_item?.order?.client?.first_name}{" "}
                          {_item?.order?.client?.last_name}
                        </span>
                      </TooltipTitle>
                    </p>
                  </ItemInfo>
                  <ItemInfo label="تاریخ درخواست">
                    <p>{convertDate(_item?.created)}</p>
                  </ItemInfo>
                  <ItemInfo label="تاریخ اعمال جریمه و رسیدگی ">
                    <p>{convertDate(_item?.end_date)}</p>
                  </ItemInfo>
                  <ItemInfo label="ثبت تا درخواست">
                    <p>{numberSeparate(_item?.until_created)} روز</p>
                  </ItemInfo>
                  <ItemInfo label="ثبت تا رسیدگی">
                    <p>{numberSeparate(_item?.until_solved)}</p>
                  </ItemInfo>
                  <ItemInfo label="کد پیگیری سفارش">
                    <p>{_item?.order?.ref_num}</p>
                  </ItemInfo>
                  <ItemInfo label="نوع خدمات">
                    <p>{_item?.order?.service}</p>
                  </ItemInfo>
                  <ItemInfo label="Personnel">
                    <p>
                      {/* IIFE (Immediately Invoked Function Expression) to determine and render personnel data */}
                      {(() => {
                        // 1. Determine the active personnel object
                        const currentPersonnel = _item?.personnel
                          ? _item.personnel // If 'personnel' exists, use it
                          : _item?.old_personnel?.personnel; // Otherwise, use 'personnel' inside 'old_personnel'

                        // 2. Check if personnel data exists
                        if (!currentPersonnel) {
                          return <span>No personnel assigned</span>;
                        }

                        // 3. Render the personnel information
                        return (
                          <span className="d-block">
                            <TooltipTitle
                              // Tooltip displays the mobile number or 'No contact number'
                              title={currentPersonnel?.mobile ?? "No contact number"}
                              placement="bottom"
                            >
                              <span className="mx-1">
                                {currentPersonnel?.first_name}{" "}
                                {currentPersonnel?.last_name}
                              </span>
                            </TooltipTitle>
                          </span>
                        );
                      })()}
                    </p>
                  </ItemInfo>
                  <ItemInfo label="نوع تخلف">
                    <p>{_item?.type?.description}</p>
                  </ItemInfo>
                  <ItemInfo label="جریمه">
                    <p className="d-flex justify-content-between align-items-center">
                      {numberSeparate(_item?.penalty || "-")}
                      {_item.status && !!_item?.penalty && (
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() =>
                            areYouSureMessage(
                              () => handleRemovePenaltyViolation(_item),
                              "آیا از بخشش جریمه اطمینان دارید؟"
                            )
                          }
                        >
                          بخشش جریمه
                        </button>
                      )}
                    </p>
                  </ItemInfo>
                  <ItemInfo label="توضیحات">
                    <p>{_item?.description || "-"}</p>
                  </ItemInfo>
                  <ItemInfo label="نظر رسیدگی کننده">
                    <p>{_item?.solved?.description || "-"}</p>
                  </ItemInfo>
                  <ItemInfo label="نتیجه نهایی">
                    <p>{_item?.result?.description || "-"}</p>
                  </ItemInfo>
                </div>
                {!isEmpty(_item?.comment) && (
                  <Table responsive hover borderless striped>
                    <thead className="thead-dark">
                      <tr>
                        <th>#</th>
                        <th className="normal-white_space">
                          توضیحات پشتیبانی و امور متخصصین
                        </th>
                        <th>پشتیبان</th>
                        <th>تاریخ ایجاد</th>
                      </tr>
                    </thead>
                    <tbody>
                      {_item?.comment?.map((_item, index) => (
                        <tr key={_item.id}>
                          <td>{index + 1}</td>
                          <td className="normal-white_space">
                            {_item?.comment}
                          </td>
                          <td>
                            {_item?.user?.first_name} {_item?.user?.last_name}
                          </td>
                          <td>{convertDate(_item.created)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            ))}
          </Tab>
        )}
        {/* Logs */}
        <Tab className="card card-body" eventKey="9" title="تاریخچه">
          {!isShowLogs ? (
            <button
              onClick={() => handleGetLogsOrder(order?.id)}
              className="btn btn-primary"
            >
              <i className="fa fa-eye" /> مشاهده تاریخچه سفارش
            </button>
          ) : (
            <>
              {isEmpty(logs) ? (
                <EmptyData title="تاریخچه ای برای نمایش یافت نشد" />
              ) : (
                <Table responsive hover borderless striped>
                  <thead className="thead-dark">
                    <tr>
                      <th>#</th>
                      <th>کاربر</th>
                      <th>شماره سفارش</th>
                      <th>تاریخ ایجاد</th>
                      <th>زمان اجرا</th>
                      <th>توضیحات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((_item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{_item.user && (_item.user.first_name + " " + _item.user.last_name)}</td>
                        <td>{_item.order.id}</td>
                        <td>{convertDate(_item.created)}</td>
                        <td>{_item.action_time}</td>
                        <td>{_item.change_message}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </>
          )}
          {activeTab === "9" && order?.id && (
            <div className="mt-4">
              <SMSDispatchLogList key={order.id} orderId={order.id} compact />
            </div>
          )}
        </Tab>
      </Tabs>

      {/* Start Personnel Modal */}
      <CustomModal
        title="ویرایش پرسنل"
        show={isShowPersonnelModal}
        onHide={handleClosePersonnelModal}
        size="lg"
      >
        {personnelStep === 1 ? (
          <>
            <div className="row">
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="نوع متخصص">
                  <select
                    className="form-control"
                    name="expert_type"
                    onChange={(e) =>
                      setExpert_type(
                        e.target.value ? Number(e.target.value) : null
                      )
                    }
                  >
                    <option value="">نوع متخصص: همه</option>
                    {expertTypeItems?.map((_value, index) => (
                      <option
                        key={index + 1}
                        selected={index + 1 === expert_type}
                        value={index + 1}
                      >
                        {_value}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="نوع فعالیت">
                  <select
                    className="form-control"
                    name="activity_type"
                    onChange={(e) =>
                      setActivity_type(
                        e.target.value ? Number(e.target.value) : null
                      )
                    }
                  >
                    <option value="">نوع فعالیت: همه</option>
                    {activityTypeItems?.map((_value, index) => (
                      <option
                        key={index + 1}
                        selected={index + 1 === activity_type}
                        value={index + 1}
                      >
                        {_value}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="وضعیت">
                  <select
                    className="form-control"
                    name="isActive"
                    onChange={(e) => setIsActive(e.target.value)}
                  >
                    <option value="">وضعیت: همه</option>
                    <option selected={"true" === isActive} value="true">
                      فعال
                    </option>
                    <option selected={"false" === isActive} value="false">
                      غیرفعال
                    </option>
                  </select>
                </TooltipTitle>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="انتخاب دسته بندی">
                  <select
                    className="form-control"
                    name="serviceCategory"
                    value={filterCategory || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFilterCategory(val === "" ? null : val);
                    }}
                  >
                    <option value="">دسته بندی: همه</option>
                    {categoriesWithId.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="شهر پرسنل">
                  <select
                    className="form-control mb-3"
                    onChange={(e) => setCity_filter(e.target.value)}
                    value={city_filter}
                  >
                    <option value="" selected={city_filter === null}>
                      همه شهرها
                    </option>
                    {cities?.map((item, index) => (
                      <option value={item.value} selected={index === city_filter}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="مرتب سازی تعداد کار">
                  <select
                    className="form-control"
                    name="workCount"
                    onChange={(e) => setWorkCount(e.target.value)}
                  >

                    <option value={null}>وضعیت: پیشفرض</option>
                    <option selected={"false" === isActive} value="desc">
                      بیشترین کار اول
                    </option>
                    <option selected={"true" === isActive} value="newest">
                      جدیدترین ها اول
                    </option>
                    <option selected={"false" === isActive} value="asc">
                      کمترین کار اول
                    </option>
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md mb-2">
                <TooltipTitle title="مرتب‌سازی بر اساس تاریخ عملکرد">
                  <select
                    className="form-control"
                    name="personnelSort"
                    value={personnelSort}
                    onChange={(e) => setPersonnelSort(e.target.value)}
                  >
                    <option value="">عملکرد: پیش‌فرض</option>
                    <option value="last_successful_job_time">قدیمی‌ترین کار موفق اول (عادلانه‌تر)</option>
                    <option value="-last_successful_job_time">جدیدترین کار موفق اول</option>
                    <option value="-last_rejected_job_time">جدیدترین انصراف/رد اول</option>
                    <option value="-last_unsuccessful_job_time">جدیدترین کار ناموفق اول</option>
                  </select>
                </TooltipTitle>
              </div>
            </div>
            <form
              className="input-group position-relative mb-2"
              onSubmit={handleGetPersonnels}
            >
              <div className="input-group-prepend">
                <TooltipTitle title="نوع" placement="bottom">
                  {personnelTypeButton(isSpecial, setIsSpecial)}
                </TooltipTitle>
              </div>
              <div className="input-group-prepend">
                <AsyncSelect
                  openMenuOnFocus
                  cacheOptions
                  placeholder="تخصص را انتخاب نمایید"
                  isLoading={isLoader}
                  noOptionsMessage={() => <p>تخصصی برای نمایش یافت نشد</p>}
                  loadingMessage={() => <p>لطفا منتظر بمانید ...</p>}
                  loadOptions={(val, callback) => {
                    handleSearchServices(val, callback);
                  }}
                  defaultOptions
                  className="w-100"
                  classNamePrefix="react-select"
                  onChange={(e) => setPersonnelType(e)}
                  value={personnelType}
                />
              </div>

              <input
                {...onTypePersonnelSearch}
                id="personnelSearch"
                name="personnelSearch"
                placeholder="نام پرسنل را وارد نمایید"
                className="form-control"
                autocomplete="off"
              />
              <div className="input-group-append">
                <button className="btn btn-primary" type="submit">
                  <i className="fa fa-search" />
                </button>
              </div>
              <div className="input-group-append">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setPersonnelType(null);
                    setTimeout(() => setPersonnels([]), 300);
                    setPersonnelSearch("");
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              </div>
            </form>

{isPersonnelLoading ? (
              <div className="text-center mt-2">
                <Spinner animation="grow" variant="success" />
              </div>
            ) : (
              !isEmpty(personnels) && (
                <div className="mt-3" style={{ maxHeight: '450px', overflowY: 'auto', overflowX: 'hidden' }}>
                  <div className="row px-1">
                    {personnels.map((_prsnl, index) => (
                      <div className="col-12 mb-3" key={_prsnl.id || _prsnl.pk}>
                        <Card className={`shadow-sm border ${index % 2 === 0 ? 'bg-white' : 'bg-light'}`}>
                          <Card.Body className="p-3">
                            <div className="row align-items-center">
                              <div className="col-auto">
                                <img
                                  src={_prsnl?.base64 ? `data:image/jpeg;base64,${_prsnl?.base64}` : defaultPicture}
                                  width={60}
                                  height={60}
                                  className="rounded-circle shadow-sm"
                                  alt="personnel"
                                />
                              </div>
                              <div className="col">
                                <h6 className="fw-bold mb-2 text-dark">
                                  {_prsnl?.first_name} {_prsnl?.last_name}
                                </h6>
                                <div className="text-muted mb-2">
                                  <span className="badge badge-info mr-2">
                                    {_prsnl?.expert_type ? expertTypeItems[_prsnl?.expert_type - 1] : "تخصص نامشخص"}
                                  </span>
                                  <span className="badge badge-secondary mr-2">
                                    وضعیت: {_prsnl?.activity_type ? activityTypeItems[_prsnl?.activity_type - 1] : "نامشخص"}
                                  </span>
                                  <span className="badge badge-secondary">
                                    کارها: {_prsnl?.work_count}
                                  </span>
                                </div>
                              </div>
                              <div className="col-auto text-left">
                                <button
                                  type="button"
                                  className="btn btn-outline-success btn-sm px-2 py-1"
                                  onClick={() => handleAddPersonnel(_prsnl)}
                                >
                                  <i className="fa fa-user-plus ml-1"></i> انتخاب
                                </button>
                              </div>
                            </div>
                            
                            <hr className="my-2" />
                            
                            <div className="row text-muted small px-2">
                              <div className="col-12 col-md-4 mb-2">
                                <i className="fa fa-phone text-primary ml-2"></i> {_prsnl?.mobile}
                              </div>
                              <div className="col-12 col-md-4 mb-2">
                                <i className="fa fa-money-bill text-primary ml-2"></i> بدهکاری: <ConvertCurrency price={_prsnl?.balance || "0"} />
                              </div>
                            </div>

                            {/* --- NEW: Performance History Timestamps Row --- */}
                            <div className="row text-muted px-2 pt-1" style={{ fontSize: "0.8rem" }}>
                              <div className="col-12 col-md-4 mb-1">
                                <span className="text-success font-weight-bold ml-1">آخرین موفق:</span> 
                                {_prsnl?.last_successful_job_time ? convertDateShort(_prsnl.last_successful_job_time) : "ثبت نشده"}
                              </div>
                              <div className="col-12 col-md-4 mb-1">
                                <span className="text-danger font-weight-bold ml-1">آخرین ناموفق:</span> 
                                {_prsnl?.last_unsuccessful_job_time ? convertDateShort(_prsnl.last_unsuccessful_job_time) : "ثبت نشده"}
                              </div>
                              <div className="col-12 col-md-4 mb-1">
                                <span className="text-warning font-weight-bold ml-1">آخرین انصراف:</span> 
                                {_prsnl?.last_rejected_job_time ? convertDateShort(_prsnl.last_rejected_job_time) : "ثبت نشده"}
                              </div>
                            </div>

                            {/* Render Extra Info if available */}
                            {(_prsnl?.about_me || _prsnl?.description) && (
                              <div className="bg-white border p-2 rounded mt-2 text-muted small">
                                {_prsnl?.about_me && (
                                  <p className="mb-1"><strong>درباره من:</strong> {_prsnl.about_me}</p>
                                )}
                                {_prsnl?.description && (
                                  <p className="mb-0"><strong>توضیحات:</strong> {_prsnl.description}</p>
                                )}
                                {_prsnl?.last_comment && (
                                  <p className="mb-0"><strong>آخرین کامنت:</strong> {_prsnl.last_comment.text}</p>
                                )}
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}

            {isEmpty(personnel_order) ? (
              <EmptyData />
            ) : (
              <>
                <Table responsive hover borderless striped>
                  <thead className="thead-dark">
                    <tr>
                      <th>#</th>
                      <th>شناسه</th>
                      <th>نام</th>
                      <th>نام خانوادگی</th>
                      <th>شماره موبایل</th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {personnel_order?.map((_item, index) => (
                      <tr key={_item.id}>
                        <td>{index + 1}</td>
                        <td>{_item.id}</td>
                        <td>{_item.first_name}</td>
                        <td>{_item.last_name}</td>
                        <td>{_item.mobile}</td>
                        <td className="mw-25">
                          <i
                            onClick={() =>
                              areYouSureMessage(
                                () => handleRemovePersonnel(_item.id),
                                `آیا از حذف پرسنل ${_item?.first_name} ${_item?.last_name} اطمینان دارید؟`
                              )
                            }
                            className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}

            <button
              className="btn btn-primary btn-block mt-3"
              onClick={() =>
                areYouSureMessage(
                  handleEditPersonnel,
                  "آیا از ویرایش پرسنل مطمئنید؟"
                )
              }
            >
              <i className="fas fa-check mr-2"></i>
              ویرایش پرسنل
            </button>
          </>
        ) : (
          <>
            <h5>ارسال پیامک به پرسنل</h5>
            <form onSubmit={handleSendSMSToPersonnel} autoComplete="off">
              <div className="row">
                <div className="col-12 mb-2">
                  <textarea
                    type="text"
                    id="personnel_notification"
                    className="form-control"
                    value={personnel_notification}
                    placeholder="متن پیامک را وارد کنید"
                    onChange={(e) => setPersonnel_notification(e.target.value)}
                    rows={15}
                  />
                </div>
              </div>
              <button className="btn btn-success" type="submit">
                <i className="fas fa-check mr-2"></i>
                ارسال پیامک به پرسنل
              </button>
              {permission.send_order_to_personnel && (
                <button
                  className="btn btn-primary ml-2"
                  type="button"
                  onClick={handleSendOrderToPersonnelSMS}
                >
                  ارسال لینک سفارش به پرسنل
                </button>
              )}
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={handleClosePersonnelModal}
              >
                انصراف از ارسال
              </button>
            </form>
          </>
        )}
      </CustomModal>
      {/* End Personnel Modal */}

      {/* Start Create Invoice Modal */}
      <CustomModal
        title="فاکتور"
        size="md"
        show={isShowInvoiceModal}
        onHide={handleCloseInvoiceModal}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!!itemName || !!itemPrice)
              return toastErrorMessage("وضعیت آیتم را مشخص کنید");
            if (invoiceId)
              areYouSureMessage(
                () => handleEditInvoice(e),
                "با ادامه عملیات فاکتور قبل لغو و فاکتور جدید جایگزین میشود، آیا از ویرایش فاکتور اطمینان دارید؟"
              );
            else handleCreateInvoice(e);
          }}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="fee">اجرت کار (ریال)</label>
              <input
                type="text"
                min={0}
                id="fee"
                name="fee"
                className="form-control"
                value={numberSeparate(fee)}
                onChange={(e) => setFee(removeNumberSeparate(e.target.value))}
              />
              <ConvertCurrencyToText price={Math.floor(fee / 10)} /> تومان
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="piece">هزینه قطعه (ریال)</label>
              <input
                type="text"
                id="piece"
                name="piece"
                className="form-control"
                value={numberSeparate(piece)}
                onChange={(e) => setPiece(removeNumberSeparate(e.target.value))}
              />
              <ConvertCurrencyToText price={Math.floor(piece / 10)} /> تومان
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="transportation">ایاب و ذهاب (ریال)</label>
              <input
                type="text"
                id="transportation"
                name="transportation"
                className="form-control"
                value={numberSeparate(transportation)}
                onChange={(e) =>
                  setTransportation(removeNumberSeparate(e.target.value))
                }
              />
              <ConvertCurrencyToText price={Math.floor(transportation / 10)} />{" "}
              تومان
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>استفاده از موجودی کیف پول کاربر {numberSeparate(order?.client?.wallet?.current_balance)} ریال</label>
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="useWallet"
                  checked={useWallet}
                  onChange={(e) => setUseWallet(e.target.checked)}
                  disabled={order?.client?.wallet?.current_balance === 0}
                />
                <label className="custom-control-label" for="useWallet" />
              </div>
            </div>
            <div className="col-12">
              <div className="input-group">
                <select
                  className="form-control"
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                >
                  <option selected value="" disabled hidden>
                    لطفا یک گزینه را انتخاب کنید
                  </option>
                  {invoiceItemTypes?.split("،")?.map((_value, index) => (
                    <option key={index + _value} value={_value}>
                      {_value}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  value={numberSeparate(itemPrice)}
                  onChange={(e) =>
                    setItemPrice(removeNumberSeparate(e.target.value))
                  }
                  placeholder="قیمت (ریال)"
                  className="form-control"
                />
                <input
                  type="text"
                  value={itemDescription}
                  onChange={(e) => setItemDescription(e.target.value)}
                  placeholder="توضیحات"
                  className="form-control"
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleAddItem}
                >
                  افزودن
                </button>
              </div>
              <br />
              {!isEmpty(extraItems) && (
                <div>
                  {extraItems?.map((item, index) => (
                    <div className="input-group mb-2" key={index}>
                      <input
                        type="text"
                        className="form-control"
                        value={item.name}
                        disabled
                      />
                      <input
                        type="text"
                        className="form-control"
                        value={numberSeparate(item.price)}
                        disabled
                      />
                      {item.description && (
                        <input
                          type="text"
                          className="form-control"
                          value={item.description}
                          disabled
                        />
                      )}
                      <button
                        onClick={() => handleRemoveItem(index)}
                        className="btn btn-danger"
                        type="button"
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="col-12 col-md-6 mb-2">
              <label>مالیات بر ارزش افزوده</label>
              <div className="d-flex justify-content-between align-items-center">
                <div className="custom-control custom-switch mb-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="isTax"
                    checked={isTax}
                    onChange={(e) => setIsTax(e.target.checked)}
                  />
                  <label className="custom-control-label" for="isTax" />
                </div>
                {isTax && (
                  <input
                    type="text"
                    id="tax"
                    name="tax"
                    className="form-control"
                    value={numberSeparate(tax)}
                    onChange={(e) =>
                      setTax(removeNumberSeparate(e.target.value))
                    }
                  />
                )}
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>فاکتور رسمی</label>
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="is_official"
                  checked={is_official}
                  onChange={(e) => setIs_official(e.target.checked)}
                />
                <label className="custom-control-label" for="is_official" />
              </div>
            </div>
            {/* <div className="col-12 col-md-6 mb-2">
              <label htmlFor="amount">مبلغ (ریال)</label>
              <input
                type="text"
                num
                min={0}
                id="amount"
                name="amount"
                className="form-control"
                value={numberSeparate(amount)}
                onChange={(e) => setAmount(removeNumberSeparate(e.target.value))}
              />
              <ConvertCurrencyToText price={Math.floor(amount/10)}/> تومان
            </div> */}
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="ref_num">جمع کل (ریال)</label>
              <input
                type="text"
                num
                min={0}
                id="total"
                name="total"
                className="form-control"
                disabled
                readOnly
                value={numberSeparate(totalInvoice)}
              />
              <ConvertCurrencyToText price={Math.floor(totalInvoice / 10)} />{" "}
              تومان
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>هزینه پرداخت شده؟</label>
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="is_paid"
                  checked={is_paid}
                  onChange={(e) => setIs_paid(e.target.checked)}
                />
                <label className="custom-control-label" for="is_paid" />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>شارژ کیف پول کاربر بعد از اتمام؟</label>
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="rechargeWallet"
                  checked={rechargeWallet}
                  disabled={order?.invoice?.is_paid || !is_paid}
                  onChange={(e) => setRechargeWallet(e.target.checked)}
                />
                <label className="custom-control-label" for="rechargeWallet" />
              </div>
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="method">نحوه پرداخت</label>
              <div className="row">
                <div className="col">
                  <input
                    id="paymentMethod1"
                    type="radio"
                    name="paymentMethod"
                    checked={invoiceMethod === 1}
                    onChange={() => setInvoiceMethod(1)}
                    className="mr-2"
                  />
                  <label htmlFor="paymentMethod1">اعتبار (کیف پول)</label>
                </div>
                <div className="col">
                  <input
                    id="paymentMethod2"
                    type="radio"
                    name="paymentMethod"
                    checked={invoiceMethod === 2}
                    onChange={() => setInvoiceMethod(2)}
                    className="mr-2"
                  />
                  <label htmlFor="paymentMethod2">درگاه پرداخت</label>
                </div>
                <div className="col">
                  <input
                    id="paymentMethod3"
                    type="radio"
                    name="paymentMethod"
                    checked={invoiceMethod === 3}
                    onChange={() => setInvoiceMethod(3)}
                    className="mr-2"
                  />
                  <label htmlFor="paymentMethod2">نقدی</label>
                </div>
              </div>
            </div>
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            {invoiceId ? "ویرایش" : "ایجاد"} فاکتور
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Personnel Details Modal */}
      <CustomModal
        title={`جزئیات پرسنل ${personnel?.first_name} ${personnel?.last_name}`}
        show={!isEmpty(personnel)}
        onHide={() => setPersonnel({})}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{personnel?.pk}</p>
            </ItemInfo>
            <ItemInfo label="نوع پرسنل">
              <p>{personnel?.type}</p>
            </ItemInfo>
            <ItemInfo label="نام">
              <p>{personnel?.first_name}</p>
            </ItemInfo>
            <ItemInfo label="نام خانوادگی">
              <p>{personnel?.last_name}</p>
            </ItemInfo>
            <ItemInfo label="تاریخ پیوستن">
              <p>{convertDate(personnel?.date_joined)}</p>
            </ItemInfo>
            {personnel?.registry_time && (
              <ItemInfo label="تاریخ ثبت نام">
                <p>{convertDate(personnel?.registry_time)}</p>
              </ItemInfo>
            )}
            {personnel?.quit_time && (
              <ItemInfo label="تاریخ خروج">
                <p>{convertDate(personnel?.quit_time)}</p>
              </ItemInfo>
            )}
            <ItemInfo label="شماره موبایل">
              <TooltipTitle
                placement="bottom"
                title={personnel?.mobile_verified ? "تایید شده" : "تایید نشده"}
              >
                <p>{personnel?.mobile}</p>
              </TooltipTitle>
            </ItemInfo>
            <ItemInfo label="نوع">
              <p>
                {personnel?.is_special ? (
                  <span className="badge badge-primary">ویژه</span>
                ) : (
                  <span className="badge badge-secondary">عادی</span>
                )}
              </p>
            </ItemInfo>
            <ItemInfo label="تعداد تخلفات">
              <p>{personnel?.violation}</p>
            </ItemInfo>
            <ItemInfo label="تعداد درخواست">
              <p>{personnel?.failurerequest}</p>
            </ItemInfo>
            {personnel?.about_me && (
              <ItemInfo label="درباره پرسنلی">
                <p>{personnel?.about_me}</p>
              </ItemInfo>
            )}
            {personnel?.description && (
              <ItemInfo label="توضیحات">
                <p>{personnel?.description}</p>
              </ItemInfo>
            )}
            {personnel?.balance !== 0 && (
              <ItemInfo label="بدهکاری کل">
                <span dir="ltr">{numberSeparate(personnel?.balance)}</span> ریال
              </ItemInfo>
            )}
            {personnel?.cooperation_percentage !== 0 && (
              <ItemInfo label="درصد همکاری">
                <p>
                  {convertPercentNumber(personnel?.cooperation_percentage)}%
                </p>
              </ItemInfo>
            )}
            {personnel?.initial_invest !== 0 && (
              <ItemInfo label="بلوکه">
                <p>{personnel?.initial_invest}</p>
              </ItemInfo>
            )}
            {personnel?.activity_type && (
              <ItemInfo label="نوع فعالیت">
                <p>{activityTypeItems[personnel?.activity_type - 1]}</p>
              </ItemInfo>
            )}
            {personnel?.expert_type && (
              <ItemInfo label="نوع متخصص">
                <p>{expertTypeItems[personnel?.expert_type - 1]}</p>
              </ItemInfo>
            )}
            <ItemInfo label="فاکتور فولاد">
              <p>{personnel?.order_with_invoices}</p>
            </ItemInfo>
            <ItemInfo label="سفارشات بدون فاکتور">
              <p>{personnel?.order_without_invoices}</p>
            </ItemInfo>
            <ItemInfo label="بازخورد گرفته نشده ">
              <p>{personnel?.without_feedbacks}</p>
            </ItemInfo>
            <ItemInfo label="تعداد نارضایتی ">
              <p>{personnel?.weak_feedbacks}</p>
            </ItemInfo>
            <ItemInfo label="درصد اعلام خرابی به تعداد کل سفارش">
              <p>{convertPercentNumber(personnel?.failurerequest_percent)}%</p>
            </ItemInfo>
            <ItemInfo label="درصد ثبت تخلف به تعداد کل سفارش ">
              <p>{convertPercentNumber(personnel?.violation_percent)}%</p>
            </ItemInfo>
            <ItemInfo label="درصد نارضایتی به تعداد کل سفارش">
              <p>{convertPercentNumber(personnel?.weak_feedbacks_percent)}%</p>
            </ItemInfo>
            <ItemInfo label="همکاری با فولاد">
              <p>
                {personnel?.working_by_foolad ? (
                  <span className="badge badge-success">توجیه شده</span>
                ) : (
                  <span className="badge badge-danger">توجیه نشده</span>
                )}
              </p>
            </ItemInfo>
            {personnel?.is_active && (
              <ItemInfo label="وضعیت">
                <p>
                  {personnel?.is_active ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیر فعال</span>
                  )}
                </p>
              </ItemInfo>
            )}
            {personnel?.start_vacation && (
              <ItemInfo label="تاریخ شروع تعطیلات">
                <p>{personnel?.start_vacation}</p>
              </ItemInfo>
            )}
            {personnel?.end_vacation && (
              <ItemInfo label="تاریخ پایان تعطیلات">
                <p>{personnel?.end_vacation}</p>
              </ItemInfo>
            )}
            <ItemInfo label="رتبه">
              <p>{personnel?.rating}</p>
            </ItemInfo>
            <ItemInfo label="شماره شبا">
              <p>{personnel?.shaba}</p>
            </ItemInfo>
            <ItemInfo label="کل کارهای پرسنل">
              <p>{personnel?.total_orders || personnel?._jobs}</p>
            </ItemInfo>
            <ItemInfo label="کارهای موفق">
              <p>
                {personnel?.success_orders_count || personnel?.success_orders}
              </p>
            </ItemInfo>
            <ItemInfo label="درصد کارهای موفق">
              <p>{convertPercentNumber(personnel?.success_orders_percent)}%</p>
            </ItemInfo>
            <ItemInfo label="کارهای کنسل شده">
              <p>
                {personnel?.cancel_orders_count || personnel?.cancel_orders}
              </p>
            </ItemInfo>
            <ItemInfo label="درصد کارهای کنسل شده">
              <p>{convertPercentNumber(personnel?.cancel_orders_percent)}%</p>
            </ItemInfo>
            {!isEmpty(personnel?.expertise) && (
              <ItemInfo label="تخصص ها">
                <p className="text-justify">
                  {personnel?.expertise?.map((expertis) => (
                    <span>{expertis?.name} - </span>
                  ))}
                </p>
              </ItemInfo>
            )}
          </div>

          {!isEmpty(personnel?.violation) && (
            <div>
              <p className="text-info fw-bold text-center">لیست تخلفات</p>

              <Table responsive hover borderless striped>
                <thead className="thead-dark text-center">
                  <tr>
                    <th>#</th>
                    <th>مشتری</th>
                    <th>تاریخ درخواست</th>
                    <th>تاریخ اعمال جریمه و رسیدگی </th>
                    <th>ثبت تا درخواست</th>
                    <th>ثبت تا رسیدگی</th>
                    <th>کد پیگیری سفارش</th>
                    <th>نوع خدمات</th>
                    <th>پرسنل</th>
                    <th>نوع تخلف</th>
                    <th>توضیحات</th>
                    <th>نظر رسیدگی کننده</th>
                    <th>نتیجه نهایی</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {personnel?.violation.map((_item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <TooltipTitle
                          title={_item?.order?.client?.mobile}
                          placement="bottom"
                        >
                          <span>
                            {_item?.order?.client?.first_name}{" "}
                            {_item?.order?.client?.last_name}
                          </span>
                        </TooltipTitle>
                      </td>
                      <td>{convertDate(_item?.created)}</td>
                      <td>{convertDate(_item?.end_date)}</td>
                      <td>{numberSeparate(_item?.until_created)} روز</td>
                      <td>{numberSeparate(_item?.until_solved)}</td>
                      <td>{_item?.order?.ref_num}</td>
                      <td>{_item?.order?.service}</td>
                      <td>
                        {!isEmpty(_item?.order?.personnel) &&
                          _item?.order?.personnel?.map(
                            (_personnelVal, index) => (
                              <span
                                className={`d-block ${index + 1 !== _item?.order?.personnel?.length
                                  ? "border-bottom"
                                  : ""
                                  }`}
                              >
                                <TooltipTitle
                                  title={_personnelVal?.mobile ?? "ندارد"}
                                  placement="bottom"
                                >
                                  <span className="mx-1">
                                    {_personnelVal?.first_name}{" "}
                                    {_personnelVal?.last_name}
                                  </span>
                                </TooltipTitle>
                              </span>
                            )
                          )}
                      </td>
                      <td>{_item?.type?.description}</td>
                      <td>{_item?.description || "-"}</td>
                      <td>{_item?.solved?.description || "-"}</td>
                      <td>{_item?.result?.description || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          <br />
          {!isEmpty(personnel?.failurerequest) && (
            <div>
              <p className="text-info fw-bold text-center">لیست درخواست</p>

              <Table responsive hover borderless striped>
                <thead className="thead-dark text-center">
                  <tr>
                    <th>#</th>
                    <th>مشتری</th>
                    <th>تاریخ درخواست</th>
                    <th>تاریخ ثبت سفارش</th>
                    <th>تاریخ نهایی</th>
                    <th>ثبت تا درخواست</th>
                    <th>چند روزه حل شد</th>
                    <th>نوع درخواست</th>
                    <th>کد پیگیری سفارش</th>
                    <th>شماره تماس کاربر</th>
                    <th>پرسنل</th>
                    <th>نتیجه نهایی</th>
                    <th>چطوری راضیش کردم؟</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {personnel?.failurerequest?.map((_item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <TooltipTitle
                          title={_item?.order?.client?.mobile}
                          placement="bottom"
                        >
                          <span>
                            {_item?.order?.client?.first_name}{" "}
                            {_item?.order?.client?.last_name}
                          </span>
                        </TooltipTitle>
                      </td>
                      <td>{convertDate(_item?.created)}</td>
                      <td>{convertDate(_item?.order?.created)}</td>
                      <td>{_item?.end_date}</td>
                      <td>{numberSeparate(_item?.until_created)} روز</td>
                      <td>{numberSeparate(_item?.until_solved)}</td>
                      <td>{_item?.request_type?.description}</td>
                      <td>{_item?.order?.ref_num}</td>
                      <td>{_item?.order?.client?.mobile}</td>
                      <td>
                        {!isEmpty(_item?.order?.personnel) &&
                          _item?.order?.personnel?.map(
                            (_personnelVal, index) => (
                              <span
                                className={`d-block ${index + 1 !== _item?.order?.personnel?.length
                                  ? "border-bottom"
                                  : ""
                                  }`}
                              >
                                <TooltipTitle
                                  title={_personnelVal?.mobile ?? "ندارد"}
                                  placement="bottom"
                                >
                                  <span className="mx-1">
                                    {_personnelVal?.first_name}{" "}
                                    {_personnelVal?.last_name}
                                  </span>
                                </TooltipTitle>
                              </span>
                            )
                          )}
                      </td>
                      <td>{_item?.result}</td>
                      <td>{_item?.customer_satisfaction_item?.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </CustomModal>
      {/* End Personnel Details Modal */}

      {/* Start Survey Modal */}
      <CustomModal
        title="نظرسنجی"
        show={isShowSurveyModal}
        onHide={handleCloseSurveyModal}
        size="lg"
      >
        <div className="text-center">
          <div className="d-felx">
            {[...Array(5)].map((_, index) => (
              <span key={index}>
                <i
                  className={`${index < rate ? "fa" : "far"
                    } fa-star text-info fa-3x`}
                  onClick={() => setRate(index + 1)}
                />
              </span>
            ))}
          </div>
          <span className="fw-bold">{rateType(rate)}</span>
        </div>
        <br />
        <div>
          <div className="row mb-4">
            <div className="col-6">
              <button
                className={`btn ${isPositiveTab ? "btn-info text-white" : "btn-outline-info"
                  } btn-block btn-lg`}
                onClick={() => setIsPositiveTab(true)}
              >
                نقاط مثبت
              </button>
            </div>
            <div className="col-6">
              <button
                className={`btn ${isPositiveTab ? "btn-outline-info" : "btn-info text-white"
                  } btn-block btn-lg`}
                onClick={() => setIsPositiveTab(false)}
              >
                نقاط منفی
              </button>
            </div>
          </div>
          <div className="row">
            {surveyItems?.map(
              (item) =>
                item.positive === isPositiveTab && (
                  <div className="col-12 col-sm-6 mb-3" key={item.id}>
                    <button
                      onClick={() => handleChangeSurveyItemList(item.id)}
                      className={`btn ${isExistingSurveyItem(item.id)
                        ? "btn-primary"
                        : "btn-outline-secondary"
                        } btn-block`}
                    >
                      <img
                        src={`${config.APP_DOWNLOAD_LINK}/static/console/${item.icon}`}
                        alt={item.description}
                        className="float-left"
                        width={27}
                        height={27}
                      />
                      <span>{item.description}</span>
                    </button>
                  </div>
                )
            )}
            <textarea
              value={surveyText}
              className="form-control p-4 shadow border-0"
              placeholder="یادداشت کنید ..."
              onChange={(e) => setSurveyText(e.target.value)}
              style={{ height: "30vh" }}
            />
            ˝
          </div>
          <div className="mt-4">
            <button
              className="btn btn-primary btn-block"
              onClick={handleSendSurvey}
            >
              <i className="fas fa-check mr-2"></i>
              ویرایش نظرسنجی
            </button>
          </div>
        </div>
      </CustomModal>
      {/* End Survey Modal */}
    </>
  );
};

export default OrderAdmin;

const OrderValues = ({ values }) => {
  if (!values) return null;

  const renderValue = (value) => {
    let render = null;

    if (value.value !== 0 && !value.value && isEmpty(value.values)) return null;

    switch (value.type) {
      case "radiobutton":
        const radioList = value.list?.split("،");
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>
            <div className="card-body">
              {radioList.map(
                (rl, index) =>
                  index === value.value && <span key={index}>{rl}</span>
              )}
            </div>
          </div>
        );
        break;
      case "multiplechoice":
        const multiplechoiceList = value.list?.split("،");
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>
            <div className="card-body">
              {multiplechoiceList.map(
                (rl, index) =>
                  index === value.value && <span key={index}>{rl}</span>
              )}
            </div>
          </div>
        );
        break;
      case "text":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body">{value.value}</div>
          </div>
        );
        break;
      case "datetime":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body text-start" dir="ltr">
              {value.value}
            </div>
          </div>
        );
        break;
      case "number":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body">{value.value}</div>
          </div>
        );
        break;
      case "switch":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body">{value.value ? "دارد" : "ندارد"}</div>
          </div>
        );
        break;
      case "item":
        render = (
          <div className="card mb-3">
            <div className="card-header">موارد انتخابی</div>{" "}
            <div className="card-body">
              {value.values?.map((primaryValue) =>
                primaryValue.values?.map((subValue) =>
                  renderItemValue(subValue)
                )
              )}
            </div>
          </div>
        );
        break;

      default:
        render = null;
        break;
    }

    return (
      <div className="col-12 col-md-6" key={Math.random()}>
        {render}
      </div>
    );
  };

  const renderItemValue = (value) => {
    let render = null;

    if (value.value !== 0 && !value.value && isEmpty(value.values)) return null;

    switch (value.type) {
      case "switch":
        render = <div className="border-bottom py-1">{value.name}</div>;
        break;
      case "number":
        render = (
          <div className="border-bottom py-1">
            {value.name} : <span>{value.value}</span>
          </div>
        );
        break;
      case "radiobutton":
        const radioList = value.list?.split("،");
        render = (
          <div className="border-bottom py-1">
            <span className="me-2">{value.name}:</span>
            <span>
              {radioList.map(
                (rl, index) =>
                  index === value.value && <span key={index}>{rl}</span>
              )}
            </span>
          </div>
        );
        break;

      default:
        render = null;
        break;
    }

    return <Fragment key={Math.random()}>{render}</Fragment>;
  };

  return (
    <div className="row col-12">
      {values.map((value) => renderValue(value))}
    </div>
  );
};

const ItemStatus = () => {
  const permission = useSelector((state) => state.permission);

  const [status, setStatus] = useState("");

  const {
    config,
    order,
    isShowCanceling,
    isShowFailing,
    cancelingItems,
    failingReasonItems,
    cancelId,
    setCancelId,
    failingId,
    setFailingId,
    handleGetCancelingReasonList,
    handleGetFailingReasonItemList,
    handleEditStatus,
    handleCloseCancelingModal,
    handleCloseFailingModal,
  } = useContext(orderAdminContext);

  const handleChange = (e) => {
    const value = e.target.value ? Number(e.target.value) : null;
    setStatus(value);
    if ([3, 5, 6].includes(value) && !isEmpty(order.personnel)) {
      modalErrorMessage(
        "سفارش دارای پرسنل است، قبل از تغییر وضعیت به حالت انتخابی باید پرسنل های سفارش حذف شوند"
      );
    } else if ([7].includes(value) && isEmpty(order.old_personnel)) {
      modalErrorMessage(
        "سفارش دارای هیچ پرسنل قدیمی نیست، قبل از تغییر وضعیت به حالت انتخابی باید پرسنل های سفارش را ویرایش کنید"
      );
    } else if ([8].includes(value) && isEmpty(order.personnel)) {
      modalErrorMessage(
        "سفارش دارای هیچ پرسنلی نیست، قبل از تغییر وضعیت به حالت انتخابی باید پرسنل های سفارش را ویرایش کنید"
      );
    } else if ([6, 8, 9, 10].includes(value)) {
      handleGetFailingReasonItemList();
    } else if ([14].includes(value) && !order.invoice?.pk) {
      modalErrorMessage(
        "سفارش دارای فاکتور نیست، قبل از تغییر وضعیت به حالت انتخابی باید فاکتور سفارش را ایجاد کنید"
      );
    }
    // else if ([10].includes(value)) {
    //   handleGetCancelingReasonList();
    // }
    else {
      areYouSureMessage(
        () => handleEditStatus(order.id, value),
        "آیا از تغییر وضعیت سفارش اطمینان دارید؟"
      );
    }
  };
  return (
    <>
      <TooltipTitle
        placement="bottom"
        title={
          config?.STATUS_CHOICES &&
          order?.status >= 0 &&
          config?.STATUS_CHOICES[order?.status]
        }
      >
        <select
          className="form-control"
          name="status"
          onChange={handleChange}
          value={order?.status}
          disabled={!permission.admin_create_update}
        >
          <option selected disabled hidden>
            لطفا وضعیت سفارش را انتخاب کنید
          </option>
          {config?.STATUS_CHOICES?.map((_value, index) => (
            <option
              key={index}
              selected={index === order?.status}
              value={index}
            >
              {_value}
            </option>
          ))}
        </select>
      </TooltipTitle>

      <CustomModal
        show={isShowCanceling}
        onHide={handleCloseCancelingModal}
        title="لغو سفارش"
      >
        <p className="alert alert-info text-center fw-bold">
          لطفا دلیل لغو سفارش از نگاه کاربر را از لیست زیر انتخاب نمایید.
        </p>

        {cancelingItems.map((item) => (
          <label htmlFor={item.id} className="select_item" key={item}>
            <span>{item.description}</span>
            <input
              type="radio"
              value={item.id}
              name="cancelOrder"
              id={item.id}
              checked={item.id == cancelId}
              onChange={() => setCancelId(item.id)}
            />
          </label>
        ))}

        <div className="row">
          <div className="col-12 col-sm-6">
            <button
              onClick={() => handleEditStatus(order.id, status)}
              className="btn btn-info text-white btn-block"
            >
              لغو سفارش
            </button>
          </div>
          <div className="col-12 col-sm-6 mt-2 mt-sm-0">
            <button
              onClick={handleCloseCancelingModal}
              type="button"
              className="btn btn-outline-info btn-block"
            >
              بازگشت
            </button>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        show={isShowFailing}
        onHide={handleCloseFailingModal}
        title="لغو سفارش"
      >
        <p className="alert alert-info text-center fw-bold">
          لطفا دلیل کنسلی سفارش کاربر را از لیست زیر انتخاب نمایید.
        </p>

        {failingReasonItems.map((item) => (
          <label htmlFor={item.id} className="select_item" key={item}>
            <span>{item.description}</span>
            <input
              type="radio"
              value={item.id}
              name="failingOrder"
              id={item.id}
              checked={item.id == failingId}
              onChange={() => setFailingId(item.id)}
            />
          </label>
        ))}

        <div className="row">
          <div className="col-12 col-sm-6">
            <button
              onClick={() => handleEditStatus(order.id, status)}
              className="btn btn-info text-white btn-block"
            >
              لغو سفارش
            </button>
          </div>
          <div className="col-12 col-sm-6 mt-2 mt-sm-0">
            <button
              onClick={handleCloseFailingModal}
              type="button"
              className="btn btn-outline-info btn-block"
            >
              بازگشت
            </button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

const ReturnUserStatusItem = () => {
  const permission = useSelector((state) => state.permission);

  const [return_user_discount, setReturn_user_discount] = useState("");
  const [return_user_percent, setReturn_user_percent] = useState("");
  const [return_user_max, setReturn_user_max] = useState("");
  const [return_user_min, setReturn_user_min] = useState("");
  const [return_user_expiration, setReturn_user_expiration] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);

  const handleResetState = () => {
    setReturn_user_discount("");
    setReturn_user_percent("");
    setReturn_user_max("");
    setReturn_user_min("");
    setReturn_user_expiration("");
  };

  // Create DiscountCoupon Modal Operations
  const handleShowModal = () => {
    setIsShowModal(true);
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  const {
    order,
    returnUserStatusItems,
    handleGetReturnUserStatusItemList,
    handleEditReturnUserStatus,
    handleEditStatus,
    handleShowEditModal,
  } = useContext(orderAdminContext);

  useEffect(() => {
    handleGetReturnUserStatusItemList();
  }, []);

  const handleDiscountCouponSubmit = (event) => {
    event?.preventDefault();
    const objData = {
      return_user_discount: Number(return_user_discount),
      return_user_percent: Number(return_user_percent),
      return_user_max: Number(return_user_max),
      return_user_min: Number(return_user_min),
      return_user_expiration: convertDate(
        return_user_expiration,
        "YYYY-M-DD HH:mm:ss"
      ),
    };
    handleEditReturnUserStatus(order.id, 3, handleCloseModal, objData);
  };

  const handleChange = (e) => {
    const value = e.target.value ? Number(e.target.value) : null;

    if ([8].includes(value)) {
      handleShowModal();
    } else {
      const onSucess = () => {
        if ([7].includes(value)) {
          const openEdit = () => {
            if (permission.admin_create_update)
              areYouSureMessage(
                handleShowEditModal,
                "با توجه به فعال شدن مجدد سفارش آیا نیاز دارید سفارش را نیز ویرایش کرده و ساعت انجام آن را تغییر دهید؟"
              );
          };
          areYouSureMessage(
            () => handleEditStatus(order.id, 0, openEdit),
            "با توجه به انتخاب گزینه «بازگشت مشتری» آیا نمایل دارید وضعیت سفارش نیز به درحال بررسی تغییر یافته و سفارش مجددا فعال شود؟",
            openEdit
          );
        }
      };
      areYouSureMessage(
        () => handleEditReturnUserStatus(order.id, value, onSucess),
        "آیا از تغییر وضعیت بازگشت مشتری اطمینان دارید؟"
      );
    }
  };

  return (
    <>
      <TooltipTitle
        placement="bottom"
        title={
          order?.returnuserstatus?.id >= 0 &&
          returnUserStatusItems?.find(
            (_value) => _value.id === order?.returnuserstatus?.id
          )?.description
        }
      >
        <select
          className="form-control"
          name="returnuserstatus"
          onChange={handleChange}
          value={order?.returnuserstatus?.id}
          disabled={!permission.admin_create_update}
        >
          <option selected disabled hidden>
            لطفا وضعیت بازگشت مشتری را انتخاب کنید
          </option>
          {returnUserStatusItems?.map((_value) => (
            <option
              key={_value?.id}
              selected={_value?.id === order?.returnuserstatus?.id}
              value={_value?.id}
            >
              {_value?.description}
            </option>
          ))}
        </select>
      </TooltipTitle>

      <CustomModal
        title="افزودن کد تخفیف"
        size="lg"
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <Alert variant="info">
          اطلاعات کد تخفیف عذرخواهی را وارد نمایید. پشتیبان گرامی دقت نمایید پس
          از ایجاد کد تخفیف، این کد به صورت خودکار برای کاربر پیامک میشود
        </Alert>
        <form onSubmit={handleDiscountCouponSubmit} autoComplete="off">
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="return_user_discount">مقدار</label>
              <input
                type="number"
                id="return_user_discount"
                name="return_user_discount"
                className="form-control"
                value={return_user_discount}
                onChange={(e) => setReturn_user_discount(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="return_user_percent">درصد</label>
              <input
                type="number"
                id="return_user_percent"
                name="return_user_percent"
                className="form-control"
                min="0"
                max="100"
                value={return_user_percent}
                onChange={(e) => setReturn_user_percent(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="return_user_max">حداکثر مبلغ تخفیف</label>
              <input
                type="number"
                id="return_user_max"
                name="return_user_max"
                className="form-control"
                value={return_user_max}
                onChange={(e) => setReturn_user_max(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="return_user_min">حداقل مبلغ فاکتور</label>
              <input
                type="number"
                id="return_user_min"
                name="return_user_min"
                className="form-control"
                value={return_user_min}
                onChange={(e) => setReturn_user_min(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="return_user_expiration">تاریخ انقضا</label>
              <CustomDateTimePicker
                initValue={return_user_expiration}
                type="single"
                onChange={(e) => setReturn_user_expiration(e)}
                todayBtn
                withTime
                autoClose={false}
                showTimeInput
              />
            </div>
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> ایجاد کد تخفیف و ارسال آن برای
            کاربر
          </button>
        </form>
      </CustomModal>
    </>
  );
};

const IntroductionUserItem = () => {
  const appConfigs = useSelector((state) => state.appConfigs);
  const introductionItems =
    appConfigs?.INTRODUCTION_CHOICES?.split("،") || [];

  const { order, handleEditUserInfo } = useContext(orderAdminContext);

  const handleChange = (e) => {
    const introduction = +e.target.value;
    areYouSureMessage(
      () => handleEditUserInfo({ introduction }),
      "آیا از تغییر نحوه آشنایی مشتری اطمینان دارید؟"
    );
  };

  if (isEmpty(introductionItems)) return null;

  if (order?.client?.introduction >= 0 && !isNull(order?.client?.introduction))
    return <span>{introductionItems[order?.client?.introduction]}</span>;

  return (
    <select
      className="form-control"
      onChange={handleChange}
      value={order?.client?.introduction}
    >
      <option selected value="" disabled hidden>
        نحوه آشنایی کاربر را انتخاب کنید
      </option>
      {introductionItems?.map((_item, index) => (
        <option key={index} value={index}>
          {_item}
        </option>
      ))}
    </select>
  );
};

const FailureRequest = () => {
  const permission = useSelector((state) => state.permission);

  const {
    order,
    request_type,
    setRequest_type,
    customer_satisfaction_item,
    setCustomer_satisfaction_item,
    failureRequestItems,
    userSatisfactionItems,
    failureRequestCommentItems,
    comment,
    setComment,
    result,
    setResult,
    isShowCreateFailureRequestModal,
    setIsShowCreateFailureRequestModal,
    handleGetFailureRequest,
    handleDeleteFailureRequest,
    handleCreateFailureRequest,
    handleEditFailureRequest,
    failureRequest,
    handleCloseCreateFailureAndViolationModal,
    handleGetFailureRequestItemList,
    handleGetUserSatisfactionItemList,
    handleGetFailureRequestCommentItemList,
  } = useContext(orderAdminContext);

  useEffect(() => {
    if (isEmpty(failureRequestItems)) handleGetFailureRequestItemList();
  }, [isShowCreateFailureRequestModal]);

  useEffect(() => {
    if (isEmpty(userSatisfactionItems)) handleGetUserSatisfactionItemList();
    if (isEmpty(failureRequestCommentItems))
      handleGetFailureRequestCommentItemList();
  }, [failureRequest]);

  const unCompleteFailureRequest = order?.failurerequest?.find(
    (_item) => !_item.status
  );

  if (!permission.failure_request_create && isEmpty(unCompleteFailureRequest))
    return null;

  return (
    <>
      <button
        className="btn btn-secondary mr-2"
        onClick={
          isEmpty(unCompleteFailureRequest)
            ? () => setIsShowCreateFailureRequestModal(true)
            : () => handleGetFailureRequest(unCompleteFailureRequest.id)
        }
      >
        درخواست
      </button>

      <CustomModal
        title="افزودن درخواست"
        show={isShowCreateFailureRequestModal}
        onHide={handleCloseCreateFailureAndViolationModal}
        size="md"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            areYouSureMessage(
              () => handleCreateFailureRequest(e),
              "در صورت تایید برای کاربر پیامک ارسال میشود، آیا از ایجاد درخواست اطمینان دارید؟"
            );
          }}
        >
          <div className="row">
            <div className="col-12 mb-3">
              <label htmlFor="request_type">نوع درخواست</label>
              <select
                id="request_type"
                className="form-control"
                value={request_type}
                onChange={(e) => setRequest_type(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {failureRequestItems?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.id}
                    selected={request_type === _item.id}
                  >
                    {_item.description}
                  </option>
                ))}
              </select>
            </div>
            {/* <div className="col-12 mb-3">
              <label htmlFor="customer_satisfaction_item">توضیحات پشتیبانی و امور متخصصین</label>

              <input
                type="text"
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div> */}
            <div className="col-12">
              <button type="submit" className="btn btn-primary btn-block">
                افزودن
              </button>
            </div>
          </div>
        </form>
      </CustomModal>

      <CustomModal
        title="جزئیات درخواست"
        show={!isEmpty(failureRequest)}
        onHide={handleCloseCreateFailureAndViolationModal}
        size="xl"
      >
        <div className="row">
          <ItemInfo label="مشتری">
            <p>
              <TooltipTitle
                title={failureRequest?.order?.client?.mobile}
                placement="bottom"
              >
                <span>
                  {failureRequest?.order?.client?.first_name}{" "}
                  {failureRequest?.order?.client?.last_name}
                </span>
              </TooltipTitle>
            </p>
          </ItemInfo>
          <ItemInfo label="تاریخ درخواست">
            <p>{convertDate(failureRequest?.created)}</p>
          </ItemInfo>
          <ItemInfo label="تاریخ ثبت سفارش">
            <p>{convertDate(failureRequest?.order?.created)}</p>
          </ItemInfo>
          <ItemInfo label="تاریخ نهایی">
            <p>{failureRequest?.end_date}</p>
          </ItemInfo>
          <ItemInfo label="ثبت تا درخواست">
            <p>{numberSeparate(failureRequest?.until_created)} روز</p>
          </ItemInfo>
          <ItemInfo label="چند روزه حل شد">
            <p>{numberSeparate(failureRequest?.until_solved)}</p>
          </ItemInfo>
          <ItemInfo label="نوع درخواست">
            <p>{failureRequest?.request_type?.description}</p>
          </ItemInfo>
          <ItemInfo label="کد پیگیری سفارش">
            <p>{failureRequest?.order?.ref_num}</p>
          </ItemInfo>
          <ItemInfo label="شماره تماس کاربر">
            <p>{failureRequest?.order?.client?.mobile}</p>
          </ItemInfo>
          <ItemInfo label="پرسنل">
            <p>
              {!isEmpty(failureRequest?.order?.personnel) &&
                failureRequest?.order?.personnel?.map(
                  (_personnelVal, index) => (
                    <span
                      className={`d-block ${index + 1 !== failureRequest?.order?.personnel?.length
                        ? "border-bottom"
                        : ""
                        }`}
                    >
                      <TooltipTitle
                        title={_personnelVal?.mobile ?? "ندارد"}
                        placement="bottom"
                      >
                        <span className="mx-1">
                          {_personnelVal?.first_name} {_personnelVal?.last_name}
                        </span>
                      </TooltipTitle>
                    </span>
                  )
                )}
            </p>
          </ItemInfo>
          <ItemInfo label="نتیجه نهایی">
            <p>{failureRequest?.result}</p>
          </ItemInfo>
          <ItemInfo label="چطوری راضیش کردم؟">
            <p>{failureRequest?.customer_satisfaction_item?.description}</p>
          </ItemInfo>
        </div>

        {permission.failure_request_update && (
          <>
            <hr />

            <form onSubmit={handleEditFailureRequest}>
              <div className="row align-items-end">
                {/* <div className="col-12 col-sm-6 col-lg-4 mb-3">
              <label htmlFor="comment">نظرات ثبت شده</label>
              <select
                id="comment"
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {failureRequestCommentItems?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.comment}
                    selected={comment === _item.comment}
                  >
                    {_item.comment}
                  </option>
                ))}
              </select>
            </div> */}
                <div className="col mb-3">
                  <label htmlFor="comment">
                    توضیحات پشتیبانی و امور متخصصین
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>
                <div className="col-12 col-lg-3 mb-3">
                  <button type="submit" className="btn btn-primary btn-block">
                    افزودن
                  </button>
                </div>
              </div>
            </form>
            {isEmpty(failureRequest?.comment) ? (
              <EmptyData />
            ) : (
              <Table responsive hover borderless striped>
                <thead className="thead-dark">
                  <tr>
                    <th>#</th>
                    <th className="normal-white_space">
                      توضیحات پشتیبانی و امور متخصصین
                    </th>
                    <th>پشتیبان</th>
                    <th>تاریخ ایجاد</th>
                  </tr>
                </thead>
                <tbody>
                  {failureRequest?.comment?.map((_item, index) => (
                    <tr key={_item.id}>
                      <td>{index + 1}</td>
                      <td className="normal-white_space">{_item?.comment}</td>
                      <td>
                        {_item?.user?.first_name} {_item?.user?.last_name}
                      </td>
                      <td>{convertDate(_item.created)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <hr />

            <form onSubmit={handleEditFailureRequest}>
              <div className="row align-items-end">
                <div className="col-12 col-sm-6 col-lg-4 mb-3">
                  <label htmlFor="customer_satisfaction_item">
                    چطوری راضیش کردم؟
                  </label>
                  <select
                    id="customer_satisfaction_item"
                    className="form-control"
                    disabled={failureRequest.status}
                    value={customer_satisfaction_item}
                    onChange={(e) =>
                      setCustomer_satisfaction_item(e.target.value)
                    }
                  >
                    <option value="" selected hidden disabled></option>
                    {userSatisfactionItems?.map((_item) => (
                      <option
                        key={_item.id}
                        value={_item.id}
                        selected={customer_satisfaction_item === _item.id}
                      >
                        {_item.description}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-sm-6 col-lg-4 mb-3">
                  <label htmlFor="result">نتیجه نهایی</label>

                  <input
                    type="text"
                    disabled={failureRequest.status}
                    className="form-control"
                    value={result}
                    onChange={(e) => setResult(e.target.value)}
                  />
                </div>
                {!failureRequest.status && (
                  <div className="col-12 col-sm-6 col-lg-2 mb-3">
                    <button type="submit" className="btn btn-success btn-block">
                      ثبت
                    </button>
                  </div>
                )}
              </div>
            </form>
            <br />
          </>
        )}
        {!failureRequest.status && (
          <>
            {permission.failure_request_update && (
              <button
                className="btn btn-primary"
                onClick={() =>
                  areYouSureMessage(
                    () => handleEditFailureRequest(null, true),
                    `آیا از اتمام درخواست اطمینان دارید؟`
                  )
                }
              >
                اتمام درخواست
              </button>
            )}
            {permission.failure_request_delete && (
              <button
                className="btn btn-danger ml-2"
                onClick={() =>
                  areYouSureMessage(
                    () => handleDeleteFailureRequest(failureRequest.id),
                    `آیا از حذف درخواست اطمینان دارید؟`
                  )
                }
              >
                حذف درخواست
              </button>
            )}
          </>
        )}
      </CustomModal>
    </>
  );
};

const Violation = () => {
  const {
    order,
    request_type,
    setRequest_type,
    personnel_id,
    setPersonnel_id,
    old_personnel_id,
    setOld_personnel_id,
    comment,
    setComment,
    isShowCreateViolationModal,
    setIsShowCreateViolationModal,
    handleGetViolation,
    handleDeleteViolation,
    violationTypeItems,
    violationSolvedItems,
    violationResultItems,
    violationCommentItems,
    solved_id,
    setSolved_id,
    penalty,
    setPenalty,
    isPenalty,
    setIsPenalty,
    result_id,
    setResult_id,
    violation,
    result,
    setResult,
    handleCloseCreateFailureAndViolationModal,
    handleCreateViolation,
    handleEditViolation,
    handleGetViolationTypeItemList,
    handleGetViolationResultItemList,
    handleGetViolationSolvedItemList,
    handleGetViolationCommentItemList,
    handleSendEducationalSMS,
  } = useContext(orderAdminContext);

  useEffect(() => {
    if (isEmpty(violationTypeItems)) handleGetViolationTypeItemList();
  }, [isShowCreateViolationModal]);

  useEffect(() => {
    if (isEmpty(violationResultItems)) handleGetViolationResultItemList();
    if (isEmpty(violationSolvedItems)) handleGetViolationSolvedItemList();
    if (isEmpty(violationCommentItems)) handleGetViolationCommentItemList();
  }, [violation]);

  const unCompleteViolation = order?.violation?.find((_item) => !_item.status);

  return (
    <>
      <button
        className="btn btn-danger mr-2"
        onClick={
          isEmpty(unCompleteViolation)
            ? () => setIsShowCreateViolationModal(true)
            : () => handleGetViolation(unCompleteViolation.id)
        }
      >
        ثبت تخلف
      </button>

      <CustomModal
        title="افزودن تخلف"
        show={isShowCreateViolationModal}
        onHide={handleCloseCreateFailureAndViolationModal}
        size="md"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            areYouSureMessage(
              () => handleCreateViolation(e),
              "در صورت تایید برای کاربر پیامک ارسال میشود، آیا از ایجاد تخلف اطمینان دارید؟"
            );
          }}
        >
          <div className="row">
            {!isEmpty(order?.personnel) && (
              <div className="col-12 mb-3">
                <label htmlFor="personnel_id">پرسنل</label>
                <select
                  id="personnel_id"
                  className="form-control"
                  value={personnel_id}
                  onChange={(e) => {
                    setPersonnel_id(e.target.value);
                    setOld_personnel_id("");
                  }}
                >
                  <option value="" selected hidden disabled></option>
                  {order?.personnel?.map((_item) => (
                    <option
                      key={_item.id}
                      value={_item.id}
                      selected={personnel_id === _item.id}
                    >
                      {_item.first_name} {_item.last_name} - {_item.mobile}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {!isEmpty(order?.old_personnel) && (
              <div className="col-12 mb-3">
                <label htmlFor="old_personnel_id">پرسنل قبل (حذف شده)</label>
                <select
                  id="old_personnel_id"
                  className="form-control"
                  value={old_personnel_id}
                  onChange={(e) => {
                    setOld_personnel_id(e.target.value);
                    setPersonnel_id("");
                  }}
                >
                  <option value="" selected hidden disabled></option>
                  {order?.old_personnel?.map((_item) => (
                    <option
                      key={_item.personnel.pk}
                      value={_item.personnel.pk}
                      selected={old_personnel_id === _item.personnel.pk}
                    >
                      {_item.personnel.first_name} {_item.personnel.last_name} - {_item.personnel.mobile}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="col-12 mb-3">
              <label htmlFor="request_type">نوع تخلف</label>
              <select
                id="request_type"
                className="form-control"
                value={request_type}
                onChange={(e) => setRequest_type(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {violationTypeItems?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.id}
                    selected={request_type === _item.id}
                  >
                    {_item.description}
                  </option>
                ))}
              </select>
            </div>
            {/* <div className="col-12 mb-3">
              <label htmlFor="customer_satisfaction_item">توضیحات پشتیبانی و امور متخصصین</label>

              <input
                type="text"
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div> */}
            <div className="col-12">
              <button type="submit" className="btn btn-primary btn-block">
                افزودن
              </button>
            </div>
          </div>
        </form>
      </CustomModal>

      <CustomModal
        title="جزئیات تخلف"
        show={!isEmpty(violation)}
        onHide={handleCloseCreateFailureAndViolationModal}
        size="xl"
      >
        <div className="row">
          <ItemInfo label="مشتری">
            <p>
              <TooltipTitle
                title={violation?.order?.client?.mobile}
                placement="bottom"
              >
                <span>
                  {violation?.order?.client?.first_name}{" "}
                  {violation?.order?.client?.last_name}
                </span>
              </TooltipTitle>
            </p>
          </ItemInfo>
          <ItemInfo label="تاریخ درخواست">
            <p>{convertDate(violation?.created)}</p>
          </ItemInfo>
          <ItemInfo label="تاریخ اعمال جریمه و رسیدگی ">
            <p>{convertDate(violation?.end_date)}</p>
          </ItemInfo>
          <ItemInfo label="ثبت تا درخواست">
            <p>{numberSeparate(violation?.until_created)} روز</p>
          </ItemInfo>
          <ItemInfo label="ثبت تا رسیدگی">
            <p>{numberSeparate(violation?.until_solved)}</p>
          </ItemInfo>
          <ItemInfo label="کد پیگیری سفارش">
            <p>{violation?.order?.ref_num}</p>
          </ItemInfo>
          <ItemInfo label="نوع خدمات">
            <p>{violation?.order?.service}</p>
          </ItemInfo>
          <ItemInfo label="پرسنل">
            <p>
              {!isEmpty(violation?.personnel) && (
                <TooltipTitle
                  title={violation?.personnel?.mobile ?? "ندارد"}
                  placement="bottom"
                >
                  <span className="mx-1">
                    {violation?.personnel?.first_name}{" "}
                    {violation?.personnel?.last_name}
                  </span>
                </TooltipTitle>
              )}
              {!isEmpty(violation?.old_personnel) && (
                <TooltipTitle
                  title={violation?.old_personnel?.mobile ?? "ندارد"}
                  placement="bottom"
                >
                  <span className="mx-1">
                    {violation?.old_personnel?.first_name}{" "}
                    {violation?.old_personnel?.last_name}
                  </span>
                </TooltipTitle>
              )}
            </p>
          </ItemInfo>
          <ItemInfo label="نوع تخلف">
            <p>{violation?.type?.description}</p>
          </ItemInfo>
          <ItemInfo label="جریمه">
            <p>{numberSeparate(violation?.penalty || "-")}</p>
          </ItemInfo>
          <ItemInfo label="توضیحات">
            <p>{violation?.description || "-"}</p>
          </ItemInfo>
          <ItemInfo label="نظر رسیدگی کننده">
            <p>{violation?.solved?.description || "-"}</p>
          </ItemInfo>
          <ItemInfo label="نتیجه نهایی">
            <p>{violation?.result?.description || "-"}</p>
          </ItemInfo>
        </div>
        <hr />
        <form onSubmit={handleEditViolation}>
          <div className="row align-items-end">
            {/* <div className="col-12 col-sm-6 col-lg-4 mb-3">
              <label htmlFor="comment">نظرات ثبت شده</label>
              <select
                id="comment"
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {violationCommentItems?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.comment}
                    selected={comment === _item.comment}
                  >
                    {_item.comment}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="col mb-3">
              <label htmlFor="customer_satisfaction_item">
                توضیحات پشتیبانی و امور متخصصین
              </label>

              <input
                type="text"
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>
            <div className="col-12 col-lg-3 mb-3">
              <button type="submit" className="btn btn-primary btn-block">
                افزودن
              </button>
            </div>
          </div>
        </form>
        {isEmpty(violation?.comment) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th className="normal-white_space">
                  توضیحات پشتیبانی و امور متخصصین
                </th>
                <th>پشتیبان</th>
                <th>تاریخ ایجاد</th>
              </tr>
            </thead>
            <tbody>
              {violation?.comment?.map((_item, index) => (
                <tr key={_item.id}>
                  <td>{index + 1}</td>
                  <td className="normal-white_space">{_item?.comment}</td>
                  <td>
                    {_item?.user?.first_name} {_item?.user?.last_name}
                  </td>
                  <td>{convertDate(_item.created)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <hr />

        <form onSubmit={handleEditViolation}>
          <div className="row align-items-end">
            <div className="col-12 col-sm-4 mb-3">
              <label>جریمه</label>
              <div className="d-flex justify-content-between align-items-center">
                <div className="custom-control custom-switch mb-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="isPenalty"
                    checked={isPenalty}
                    onChange={(e) => setIsPenalty(e.target.checked)}
                  />
                  <label className="custom-control-label" for="isPenalty" />
                </div>
                <input
                  type="text"
                  id="tax"
                  name="tax"
                  className="form-control"
                  disabled={!isPenalty}
                  value={numberSeparate(penalty)}
                  onChange={(e) =>
                    setPenalty(removeNumberSeparate(e.target.value))
                  }
                />
              </div>
            </div>
            <div className="col-12 col-sm-4 mb-3">
              <label htmlFor="solved_id">نظر رسیدگی کننده</label>
              <select
                id="solved_id"
                disabled={violation.status}
                className="form-control"
                value={solved_id}
                onChange={(e) => setSolved_id(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {violationSolvedItems?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.id}
                    selected={solved_id === _item.id}
                  >
                    {_item.description}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-sm-4 mb-3">
              <label htmlFor="result_id">نتیجه نهایی</label>
              <select
                id="result_id"
                disabled={violation.status}
                className="form-control"
                value={result_id}
                onChange={(e) => setResult_id(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {violationResultItems?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.id}
                    selected={result_id === _item.id}
                  >
                    {_item.description}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-sm-6 col-lg-8 mb-3">
              <label htmlFor="result">توضیحات</label>

              <input
                type="text"
                disabled={violation.status}
                className="form-control"
                value={result}
                onChange={(e) => setResult(e.target.value)}
              />
            </div>
            {!violation.status && (
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <button type="submit" className="btn btn-success btn-block">
                  ثبت
                </button>
              </div>
            )}
          </div>
        </form>
        <br />

        {!violation.status && (
          <>
            <button
              className="btn btn-primary"
              onClick={() =>
                areYouSureMessage(
                  () => handleEditViolation(null, true),
                  `آیا از اتمام تخلف اطمینان دارید؟`
                )
              }
            >
              اتمام تخلف
            </button>
            {/* <button
              className="btn btn-danger ml-2"
              onClick={() =>
                areYouSureMessage(
                  () => handleDeleteViolation(violation?.id),
                  `آیا از حذف تخلف اطمینان دارید؟`
                )
              }
            >
              حذف تخلف
            </button> */}
          </>
        )}
        <hr />

        <h5>ارسال پیامک آموزشی</h5>
        <form onSubmit={handleSendEducationalSMS} autoComplete="off">
          <div className="row">
            <div className="col-12 mb-2">
              <textarea
                type="text"
                id="message"
                className="form-control"
                placeholder="متن پیامک را وارد کنید"
                rows={7}
              />
            </div>
          </div>
          <button className="btn btn-success btn-block" type="submit">
            <i className="fas fa-check mr-2"></i>
            ارسال
          </button>
        </form>
      </CustomModal>
    </>
  );
};

const Comments = () => {
  const { comments, handleAddComment } = useContext(orderAdminContext);

  const [replyTo, setReplyTo] = useState(null);

  const input = (placeholder) => (
    <div className="mt-3">
      {replyTo && (
        <div className="bg-light rounded mb-2 p-2">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              در حال پاسخ به:
              <span className="font-weight-bold text-primary ml-2">
                {replyTo.user?.first_name} {replyTo.user?.last_name}
              </span>
            </span>
            <i
              className="fa fa-times text-danger cursorPointer"
              onClick={() => setReplyTo(null)}
            />
          </div>
          <hr className="my-2" />
          <span>{replyTo.text}</span>
        </div>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddComment(e, replyTo?.id);
          setReplyTo(null);
        }}
        className="input-group"
      >
        <input
          name="comment"
          className="form-control"
          placeholder={placeholder}
        />
        <div className="input-group-append">
          <button type="submit" className="btn btn-primary">
            ارسال
          </button>
        </div>
      </form>
    </div>
  );

  const comment = (_item) => (
    <div
      key={_item.id}
      className={`p-2 rounded my-1 ${_item.parent ? "bg-light ml-4 border-white" : "bg-white"
        } border`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span className="font-weight-bold text-dark">
          {_item.user?.first_name} {_item.user?.last_name}
        </span>
        <span className="text-muted">{convertDate(_item.created)}</span>
      </div>
      <hr className="my-1" />
      <div className="d-flex justify-content-between align-items-end">
        <p className="text-dark mb-0">{_item.text}</p>
        <i
          className="fa fa-share text-primary cursorPointer"
          onClick={() => setReplyTo(_item)}
        />
      </div>
      {!isEmpty(_item.replies) && (
        <div className="mt-3">{_item.replies?.map(comment)}</div>
      )}
    </div>
  );

  return (
    <>
      <h5>گفتگو</h5>
      {!isEmpty(comments) && <>{comments?.map(comment)}</>}
      {input(`${replyTo ? "پاسخ" : "پیام"} خود را وارد کنید`)}
    </>
  );
};

const CleaningCalculator = () => {
  const { order, cities, setFee, setTransportation, setAmount, handleSaveOrderCleaningParams } = useContext(orderAdminContext);

  // Detect Pro Cleaning ("نظافت ویژه")
  const isProCleaning = order?.service?.name?.includes("نظافت ویژه");

  // Find the exact city settings object that matches the order's city id
  const orderCityId = order?.city?.id || order?.city;
  const matchedCity = cities?.find((c) => c.id === orderCityId);
  const citySettings = matchedCity?.settings || {};

  // Fallback to default rates if city settings aren't found
  const DEFAULT_HOURLY = isProCleaning 
    ? (Number(citySettings.PRO_CLEANING_HOURLY_RATE) || 3500000) 
    : (Number(citySettings.STANDARD_CLEANING_HOURLY_RATE) || 2500000);

  const DEFAULT_TRANSPORT_RATE = Number(citySettings.TRANSPORT_RATE) || 1000000;
  
  const defaultCommission = order?.commission_percent ?? order?.personnel?.[0]?.cooperation_percentage ?? 25;

  const [isExpanded, setIsExpanded] = useState(true);

  // Editable Rates initialized with the specific city settings
  const [hourlyRate, setHourlyRate] = useState(DEFAULT_HOURLY);
  const [transportRate, setTransportRate] = useState(DEFAULT_TRANSPORT_RATE);
  const [commissionPercent, setCommissionPercent] = useState(defaultCommission);

  // Pre-fill from order fields
  const [startTime, setStartTime] = useState(order?.cleaning_start_time || "");
  const [endTime, setEndTime] = useState(order?.cleaning_end_time || "");
  const [discountPercent, setDiscountPercent] = useState(0);
  const [discountCap, setDiscountCap] = useState(0);
  
  const [needsTransportGo, setNeedsTransportGo] = useState(order?.transport_go ?? true);
  const [needsTransportReturn, setNeedsTransportReturn] = useState(order?.transport_return ?? true);

  // Notification Options
  const [sendToClient, setSendToClient] = useState(order?.send_to_client ?? false);
  const [sendToPersonnel, setSendToPersonnel] = useState(order?.send_to_personnel ?? false);

  // Sync state if order or cities data update asynchronously
  useEffect(() => {
    if (order) {
      if (order.cleaning_start_time) setStartTime(order.cleaning_start_time);
      if (order.cleaning_end_time) setEndTime(order.cleaning_end_time);
      if (order.transport_go !== undefined) setNeedsTransportGo(order.transport_go);
      if (order.transport_return !== undefined) setNeedsTransportReturn(order.transport_return);
      if (order.commission_percent !== undefined) setCommissionPercent(order.commission_percent);
      if (order.send_to_client !== undefined) setSendToClient(order.send_to_client);
      if (order.send_to_personnel !== undefined) setSendToPersonnel(order.send_to_personnel);
    }
  }, [order, cities]);

  // Update rates dynamically if matchedCity/citySettings loads or changes
  useEffect(() => {
    if (citySettings.PRO_CLEANING_HOURLY_RATE) {
      setHourlyRate(
        isProCleaning 
          ? Number(citySettings.PRO_CLEANING_HOURLY_RATE) 
          : Number(citySettings.STANDARD_CLEANING_HOURLY_RATE)
      );
    }
    if (citySettings.TRANSPORT_RATE) {
      setTransportRate(Number(citySettings.TRANSPORT_RATE));
    }
  }, [matchedCity, isProCleaning]);

  const startTimeRef = useRef(null);

  useEffect(() => {
    if (isExpanded && startTimeRef.current) {
      startTimeRef.current.focus();
    }
  }, [isExpanded]);

  const handleTimeInput = (e, setter) => {
    let val = e.target.value.replace(/\D/g, ""); 
    if (val.length > 4) val = val.slice(0, 4);
    if (val.length >= 2) {
      let hours = parseInt(val.slice(0, 2), 10);
      if (hours > 23) val = `23${val.slice(2)}`;
    }
    if (val.length >= 3) {
      val = `${val.slice(0, 2)}:${val.slice(2)}`;
    }
    if (val.length === 5) {
      let mins = parseInt(val.slice(3, 5), 10);
      if (mins > 59) val = `${val.slice(0, 3)}59`;
    }
    setter(val);
  };

  const getDecimalHours = (timeStr) => {
    if (!timeStr || timeStr.length < 5) return 0;
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours + (minutes / 60);
  };

  let calcHours = 0;
  if (startTime.length === 5 && endTime.length === 5) {
    calcHours = getDecimalHours(endTime) - getDecimalHours(startTime);
    if (calcHours < 0) calcHours += 24; 
  }
  
  const totalHours = Math.round(calcHours * 100) / 100; 
  const baseFee = totalHours * hourlyRate;
  
  const transportMultiplier = (needsTransportGo ? 1 : 0) + (needsTransportReturn ? 1 : 0);
  const transportFee = transportMultiplier * transportRate;
    
  const totalWithoutDiscount = baseFee + transportFee;

  let discountAmount = baseFee * (discountPercent / 100);
  if (discountCap > 0 && discountAmount > discountCap) {
    discountAmount = discountCap;
  }
  
  const totalWithDiscount = totalWithoutDiscount - discountAmount;
  const discountedBaseFee = baseFee - discountAmount;
  
  const karbamaShare = discountedBaseFee * (commissionPercent / 100);
  const cleanerShare = (discountedBaseFee - karbamaShare) + transportFee;

  const formatCurrency = (num) => new Intl.NumberFormat('fa-IR').format(num);

  const applyAndSaveToOrder = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFee(baseFee);
    setTransportation(transportFee);
    setAmount(discountAmount); 

    handleSaveOrderCleaningParams({
      cleaning_start_time: startTime,
      cleaning_end_time: endTime,
      transport_go: needsTransportGo,
      transport_return: needsTransportReturn,
      commission_percent: commissionPercent,
      send_to_client: sendToClient,
      send_to_personnel: sendToPersonnel
    });
  };

  return (
    <div className="card shadow-sm mb-4 border-warning">
      <div 
        className="card-header bg-warning text-dark d-flex justify-content-between align-items-center"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center">
          <i className={`fa fa-chevron-${isExpanded ? "up" : "down"}`} />
          <span className="font-weight-bold h5 mb-0 mr-3">
            ماشین حساب نظافت {isProCleaning && <span className="badge badge-dark ml-2">ویژه (Pro)</span>}
            {matchedCity && <span className="badge badge-light text-dark ml-2">شهر: {matchedCity.name}</span>}
          </span>
        </div>
        
        {isExpanded && (
          <button className="btn btn-sm btn-dark" onClick={applyAndSaveToOrder} type="button">
            ذخیره روی سفارش و انتقال به فاکتور <i className="fa fa-check ml-1"/>
          </button>
        )}
      </div>
      
      {isExpanded && (
        <div className="card-body">
          <div className="row mb-3 bg-white border border-light p-3 rounded mx-1 shadow-sm">
            <div className="col-12 pb-2 fw-bold text-primary">
              <i className="fa fa-cog ml-2"></i>تنظیمات پایه ({isProCleaning ? 'تعرفه نظافت ویژه' : 'تعرفه استاندارد'} - {matchedCity?.name || 'شهر پیش‌فرض'})
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label text-muted small">تعرفه ساعتی (ریال)</label>
              <input type="number" className="form-control" value={hourlyRate} onChange={(e) => setHourlyRate(Number(e.target.value))} />
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label text-muted small">تعرفه ایاب و ذهاب (هر مسیر) (ریال)</label>
              <input type="number" className="form-control" value={transportRate} onChange={(e) => setTransportRate(Number(e.target.value))} />
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label text-muted small">کمیسیون کارباما (٪)</label>
              <input type="number" min="0" max="100" className="form-control" value={commissionPercent} onChange={(e) => setCommissionPercent(Number(e.target.value))} />
            </div>
          </div>

          <hr className="my-4 text-muted" />

          <div className="row mb-3">
            <div className="col-12 col-md-3 mb-2">
              <label className="form-label">ساعت ورود</label>
              <input 
                type="text" 
                inputMode="numeric"
                placeholder="14:45"
                className="form-control text-center fw-bold" 
                value={startTime}
                ref={startTimeRef} 
                onChange={(e) => handleTimeInput(e, setStartTime)} 
              />
            </div>
            <div className="col-12 col-md-3 mb-2">
              <label className="form-label">ساعت خروج</label>
              <input 
                type="text" 
                inputMode="numeric"
                placeholder="19:00"
                className="form-control text-center fw-bold" 
                value={endTime} 
                onChange={(e) => handleTimeInput(e, setEndTime)} 
              />
            </div>
            <div className="col-12 col-md-3 mb-2">
              <label className="form-label">درصد تخفیف</label>
              <input type="number" min="0" max="100" className="form-control text-center" value={discountPercent} onChange={(e) => setDiscountPercent(Number(e.target.value))} />
            </div>
            <div className="col-12 col-md-3 mb-2">
              <label className="form-label">سقف تخفیف (ریال)</label>
              <input type="number" min="0" className="form-control text-center" value={discountCap} onChange={(e) => setDiscountCap(Number(e.target.value))} />
            </div>
          </div>

          <div className="row mb-3 bg-light p-3 rounded mx-1">
            <div className="col-12 pb-2 fw-bold text-muted">وضعیت ایاب و ذهاب و اطلاع‌رسانی</div>
            <div className="col-12 col-md-6 mb-2">
              <div className="custom-control custom-switch">
                <input type="checkbox" className="custom-control-input" id="transportGo" checked={needsTransportGo} onChange={(e) => setNeedsTransportGo(e.target.checked)} />
                <label className="custom-control-label fw-bold" htmlFor="transportGo">
                  مسیر رفت ({formatCurrency(transportRate)} ریال)
                </label>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <div className="custom-control custom-switch">
                <input type="checkbox" className="custom-control-input" id="transportReturn" checked={needsTransportReturn} onChange={(e) => setNeedsTransportReturn(e.target.checked)} />
                <label className="custom-control-label fw-bold" htmlFor="transportReturn">
                  مسیر برگشت ({formatCurrency(transportRate)} ریال)
                </label>
              </div>
            </div>
            <div className="col-12 col-md-6 mt-2">
              <div className="custom-control custom-switch">
                <input type="checkbox" className="custom-control-input" id="sendClient" checked={sendToClient} onChange={(e) => setSendToClient(e.target.checked)} />
                <label className="custom-control-label" htmlFor="sendClient">ارسال جزئیات برای مشتری</label>
              </div>
            </div>
            <div className="col-12 col-md-6 mt-2">
              <div className="custom-control custom-switch">
                <input type="checkbox" className="custom-control-input" id="sendPersonnel" checked={sendToPersonnel} onChange={(e) => setSendToPersonnel(e.target.checked)} />
                <label className="custom-control-label" htmlFor="sendPersonnel">ارسال جزئیات برای پرسنل</label>
              </div>
            </div>
          </div>

          <div className="row text-center">
            <div className="col-6 col-md-3 mb-2">
              <div className="p-2 border rounded bg-white h-100">
                <small className="text-muted d-block mb-1">مقدار ساعت محاسبه شده</small>
                <h5 className="fw-bold m-0" dir="ltr">{totalHours}</h5>
              </div>
            </div>
            <div className="col-6 col-md-3 mb-2">
              <div className="p-2 border rounded bg-white h-100">
                <small className="text-muted d-block mb-1">هزینه ایاب و ذهاب</small>
                <h5 className="fw-bold text-info m-0">{formatCurrency(transportFee)}</h5>
              </div>
            </div>
            <div className="col-6 col-md-3 mb-2">
              <div className="p-2 border border-warning rounded bg-warning text-dark h-100">
                <small className="d-block mb-1">مبلغ نهایی با تخفیف</small>
                <h5 className="fw-bold m-0">{formatCurrency(totalWithDiscount)}</h5>
              </div>
            </div>
            <div className="col-6 col-md-3 mb-2">
              <div className="p-2 border border-success rounded bg-success text-white h-100">
                <small className="d-block mb-1">سهم نظافتچی</small>
                <h5 className="fw-bold m-0">{formatCurrency(cleanerShare)}</h5>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
